        <template>
            <div class="evaluationPage-container">
                <!-- 页面头部 -->
                <div class="page-header">
                    <div class="header-left">
                        <h1 class="page-title">{{ title }}</h1>
                    </div>
                    <div class="header-right">
                        <el-button type="primary" class="return-btn" @click="handleBack">返回</el-button>
                    </div>
                </div>
                <!-- 功能卡片区域 -->
                <div class="function-cards-section">
                    <div class="cards-grid">
                        <!-- 功能卡片 -->
                        <div class="card-row" v-for="(rowCards, rowIndex) in functionCardsRows" :key="rowIndex">
                            <div v-for="card in rowCards" :key="card.title" class="function-card"
                                @click="handleOpenDrawer(card.title)">
                                <div class="card-icon">
                                    <i :class="card.icon"></i>
                                </div>
                                <div class="card-text">{{ card.title }}</div>
                            </div>
                        </div>
                        <!-- 聊天入口按钮（仅当 projectType==01 时显示） -->
                        <div class="card-row" v-if="projectType != '01'">
                            <div class="function-card" @click="handleOpenChat">
                                <div class="card-icon">
                                    <i class="el-icon-chat-dot-round"></i>
                                </div>
                                <div class="card-text">聊天</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 评审步骤表格区域  0601 0602 二次报价 和小微企业认证环节　  -->
                <div class="review-steps-section">
                    <el-table :data="filteredReviewStepsConfig" border style="width: 100%" max-height="450"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                        :cell-style="{ color: '#303133' }">
                        <el-table-column prop="step" label="评审步骤" width="100" align="center">
                            <template slot-scope="scope">
                                第{{ scope.$index + 1 }}步
                            </template>
                        </el-table-column>
                        <el-table-column prop="stepName" label="节点名称" min-width="200"></el-table-column>
                        <el-table-column prop="expertNames" label="节点状态" min-width="200" align="center" />
                        <el-table-column prop="review" label="评审" min-width="200" align="center">
                            <template slot-scope="scope">
                                <!--  遍历数组 查看数组中的 completed  如果都是0的话 第一个节点可点击  剩下的都不可见。  如果第一个节点为1的话  第1，2 可见。以此类推-->
                                <!--  -->
                                <template v-if="isStepVisible(scope.$index)">
                                    <template v-if="scope.row.stepTypeCode == '01' || scope.row.stepTypeCode == '02'">
                                        <el-button type="primary" size="small" @click="handleStartReview(scope.row)"
                                            :disabled="scope.row.completed == 1" v-if="scope.row.completed != 1">
                                            开始评审
                                        </el-button>
                                        <!-- 编辑 -->
                                        <el-button :type="scope.row.skip == 1 ? 'danger' : 'primary'" size="small"
                                            @click="handleStartReview(scope.row)" v-if="scope.row.completed == 1">
                                            {{ scope.row.skip == 1 ? '跳过' : '编辑' }}
                                        </el-button>
                                    </template>
                                    <template
                                        v-else-if="scope.row.stepTypeCode == '03' || scope.row.stepTypeCode == '04'">
                                        <!-- 计算基准价 / 计算报价得分：仅组长可操作 -->
                                        <template v-if="role == '1'">
                                            <el-button type="warning" size="small"
                                                @click="handleStartCalculate(scope.row)"
                                                :disabled="scope.row.completed == 1" v-if="scope.row.completed != 1">
                                                开始计算
                                            </el-button>
                                            <!-- 编辑 -->
                                            <el-button :type="scope.row.skip == 1 ? 'danger' : 'primary'" size="small"
                                                @click="handleStartCalculate(scope.row)"
                                                v-if="scope.row.completed == 1">
                                                {{ scope.row.skip == 1 ? '跳过' : '编辑' }}
                                            </el-button>
                                        </template>
                                        <!-- 组员只能查看 -->
                                        <template v-else>
                                            <el-button type="info" size="small" @click="handleViewCalculate(scope.row)">
                                                查看
                                            </el-button>
                                        </template>
                                    </template>
                                    <template v-else-if="scope.row.stepTypeCode == '05'">
                                        <!-- 推荐中标候选人：仅组长可操作 -->
                                        <template v-if="role == '1'">
                                            <el-button type="danger" size="small"
                                                @click="handleStartRecommendWinnerCandidate(scope.row)"
                                                :disabled="scope.row.completed == 1" v-if="scope.row.completed != 1">
                                                推荐中标候选人
                                            </el-button>
                                            <!-- 编辑 -->
                                            <el-button type="success" size="small"
                                                @click="handleStartRecommendWinnerCandidate(scope.row)"
                                                v-if="scope.row.completed == 1">
                                                修改中标候选人
                                            </el-button>

                                            <el-button type="danger" size="small"
                                                @click="handleStartRecommendWinner(scope.row)"
                                                v-if="scope.row.completed == 1">
                                                查看
                                            </el-button>
                                        </template>
                                        <!-- 组员只能查看 -->
                                        <template v-else>
                                            <el-button type="info" size="small"
                                                @click="handleStartRecommendWinner(scope.row)">
                                                查看
                                            </el-button>
                                        </template>
                                    </template>
                                    <template v-else-if="scope.row.stepTypeCode == '0601'">
                                        <el-button type="success" size="small"
                                            @click="handleStartRecommendWinnerCandidate(scope.row)"
                                            :disabled="scope.row.completed == 1" v-if="scope.row.completed != 1">
                                            开始报价
                                        </el-button>
                                        <!-- 编辑 -->
                                        <el-button type="success" size="small"
                                            @click="handleStartRecommendWinnerCandidate(scope.row)"
                                            v-if="scope.row.completed == 1">
                                            编辑
                                        </el-button>
                                    </template>
                                    <template v-else-if="scope.row.stepTypeCode == '0602'">
                                        <el-button type="success" size="small"
                                            @click="handleStartRecommendWinnerCandidate(scope.row)"
                                            :disabled="scope.row.completed == 1">
                                            开始认证
                                        </el-button>
                                        <!-- 编辑 -->
                                        <el-button type="success" size="small"
                                            @click="handleStartRecommendWinnerCandidate(scope.row)"
                                            v-if="scope.row.completed == 1">
                                            编辑
                                        </el-button>
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 底部操作按钮区域 -->
                <div class="bottom-actions-section">
                    <el-button v-if="showSecondButtons" type="primary" class="action-btn"
                        @click="handlebottomAction('二次报价')">二次报价</el-button>
                    <el-button type="primary" class="action-btn" @click="handlebottomAction('查看报价')"
                        v-if="showSecondButtonsCheck">查看报价</el-button>
                    <el-button type="primary" class="action-btn" @click="handlebottomAction('小微企业审核')"
                        v-if="showMicroEnterpriseReview">小微企业审核</el-button>
                    <el-button type="primary" class="action-btn" @click="openReportDialog">
                        查看评审报告
                    </el-button>
                    <el-button type="primary" class="action-btn" @click="handleEvaluationEndUpdate"
                        v-if="showEvaluationEndButton">
                        评标结束
                    </el-button>
                </div>
                <!-- 打开投标文件弹窗 -->
                <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="direction"
                    :before-close="handleClose" size="80%">
                    <div class="drawer-content">
                        <!-- 左侧边栏 -->
                        <div class="drawer-content-left">
                            <div class="dropdown-section">
                                <el-select v-model="userId" placeholder="请选择投标单位" class="project-select"
                                    @change="handleBidderChange">
                                    <el-option :label="item.userName" :value="item.userId" v-for="item in bidderList"
                                        :key="item.userId"></el-option>
                                </el-select>
                            </div>
                            <!-- 章节视图标题 -->
                            <div class="chapter-title">
                                <h3>章节视图</h3>
                            </div>
                            <!-- 章节目录树 -->
                            <div class="chapter-tree">
                                <el-tree :data="catalogueList" :props="{ label: 'catalogueName', children: 'children' }"
                                    node-key="strId" :default-expanded-keys="defaultExpandedKeys" highlight-current
                                    @node-click="handleCatalogueClick">
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <span>{{ data.catalogueName }}</span>
                                        <span class="page-num">P{{ data.pageNum }}</span>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                        <!-- 右侧内容区域 -->
                        <div class="drawer-content-right">
                            <!-- PDF查看器 -->
                            <div class="pdf-viewer-container">
                                <div style="flex: 1; min-width: 0; height: 100%; overflow: auto;">
                                    <PdfViewer ref="pdfViewer" :pdf-url="basePdfUrl" :show-toolbar="true"
                                        :initial-scale="1.0" @pdf-loaded="onPdfLoaded" @pdf-error="onPdfError"
                                        @page-changed="onPageChanged" @scale-changed="onScaleChanged" />
                                </div>
                            </div>
                        </div>
                    </div>
                </el-drawer>
                <!-- 打开招标文件弹窗 -->
                <el-drawer :title="drawerTitle" :visible.sync="drawer1" :direction="direction"
                    :before-close="handleClose" size="50%">
                    <div class="drawer-content">
                        <div class="drawer-content-right">
                            <PdfViewer :pdf-url="basePdfUrl" :show-toolbar="true" :initial-scale="1.0"
                                @pdf-loaded="onPdfLoaded" @pdf-error="onPdfError" @page-changed="onPageChanged"
                                @scale-changed="onScaleChanged" />
                        </div>
                    </div>
                </el-drawer>
                <!-- 招标文件附件弹窗 -->
                <el-dialog title="招标文件附件" :visible.sync="attachmentDialogVisible" width="800px"
                    :before-close="handleAttachmentDialogClose" class="attachment-dialog">
                    <div class="attachment-dialog-content">
                        <!-- 附件分类标签页（根据接口返回的 fileExtension 动态生成） -->
                        <el-tabs v-model="activeAttachmentTab" class="attachment-tabs">
                            <el-tab-pane v-for="type in attachmentTypes" :key="type" :label="type" :name="type">
                                <div class="attachment-section">
                                    <el-table :data="attachmentData[type]" border stripe
                                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                        :cell-style="{ color: '#303133' }" class="attachment-table">
                                        <el-table-column prop="no" label="NO." width="80"
                                            align="center"></el-table-column>
                                        <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="200">
                                            <template slot-scope="scope">
                                                <el-link v-if="scope.row.fileName" type="primary"
                                                    @click="handleFileDownload(scope.row)" class="file-link">
                                                    {{ scope.row.fileName }}
                                                </el-link>
                                                <span v-else class="no-data">暂无数据</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                            <div v-if="!attachmentTypes.length" class="attachment-section">
                                <div class="section-header">
                                    <span class="section-title">暂无附件</span>
                                </div>
                            </div>
                        </el-tabs>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleAttachmentDialogClose">关闭</el-button>
                    </div>
                </el-dialog>
                <!-- 附件查看弹窗 -->
                <el-dialog title="附件" :visible.sync="attachmentViewDialogVisible" width="600px">
                    <el-table :data="attachmentViewList" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', fontWeight: 'bold' }">
                        <el-table-column prop="fileName" label="文件名称" min-width="260"></el-table-column>
                        <el-table-column prop="fileType" label="文件类型" width="120" align="center"></el-table-column>
                        <el-table-column prop="fileSize" label="文件大小" width="120" align="center"></el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="attachmentViewDialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>
                <!-- 小微企业审核弹窗 -->
                <el-drawer title="小微企业审核" :visible.sync="microAuditDrawerVisible" :direction="direction" size="90%">
                    <div style="display:flex; gap:16px; height: calc(100vh - 120px); padding: 0 12px;">
                        <div style="flex:1; display:flex; flex-direction:column;">
                            <div style="padding: 8px 0; display:flex; justify-content:start;">
                                <el-select v-model="selectedMicroCompany" placeholder="请选择单位" style="width: 260px;"
                                    @change="handleChange">
                                    <el-option v-for="opt in microAuditCompanyOptions" :key="opt.value"
                                        :label="opt.userName" :value="opt.userId" />
                                </el-select>
                            </div>
                            <div style="flex:1; background:#eee; border-radius:6px; overflow:auto; display:flex;">
                                <div style="flex:1; min-width:0; height:100%; padding:8px;">
                                    <PdfViewer :pdf-url="pdfUrl" :show-toolbar="true" :initial-scale="1.0"
                                        @pdf-loaded="onPdfLoaded" @pdf-error="onPdfError" @page-changed="onPageChanged"
                                        @scale-changed="onScaleChanged" />
                                </div>
                            </div>
                        </div>
                        <div style="flex:1; display:flex; flex-direction:column; overflow:auto; padding-top: 8px;">
                            <div style="display:flex; justify-content:flex-end; margin-bottom:8px;">
                                <el-button type="primary" size="small" @click="handleSaveMicroAudit">
                                    保存
                                </el-button>
                            </div>
                            <div v-for="item in microAuditList" :key="item.userId"
                                style="padding:12px 0; border-bottom:1px solid #f0f0f0;">
                                <div style="font-weight:600; margin-bottom:8px;  text-align: start;">单位名称</div>
                                <div style="margin-bottom:8px; text-align: start;">{{ item.userName }}</div>
                                <div style="display:flex; align-items:center; gap:12px; margin-bottom:8px;">
                                    <div>小微企业</div>
                                    <el-radio-group v-model="item.isDiscount">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="0">否</el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="item.isDiscount"
                                    style="display:flex; align-items:center; gap:8px; max-width:360px;">
                                    <div style="min-width:72px;">优惠幅度</div>
                                    <el-input v-model="item.discount" placeholder="" />
                                    <div>%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-drawer>
                <!-- 二次报价清单弹窗 -->
                <el-dialog title="二次报价清单" :visible.sync="secondQuoteDialogVisible" width="700px"
                    :close-on-click-modal="false" :close-on-press-escape="false">
                    <div style="text-align: right; margin-bottom: 10px;">
                        <el-button type="primary" size="mini" @click="addSecondQuoteItem"
                            v-if="countdown == 0">新增</el-button>
                    </div>
                    <el-table :data="secondQuoteList" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }">
                        <el-table-column prop="itemName" label="条目名称" min-width="300">
                            <template slot-scope="scope">
                                <el-input v-if="scope.row.editing || !scope.row.itemName" v-model="scope.row.itemName"
                                    placeholder="请输入条目名称" size="small" @keyup.enter.native.stop />
                                <span v-else>{{ scope.row.itemName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini"
                                    @click="removeSecondQuoteItem(scope.$index, scope.row)"
                                    v-if="countdown == 0">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 投标单位选择 -->
                    <div style="margin-bottom: 15px; padding: 10px; background: #f5f7fa; border-radius: 4px;">
                        <div style="margin-bottom: 8px; font-weight: bold; color: #333;">选择投标单位：</div>
                        <el-checkbox-group v-model="selectedBidders" :disabled="countdown > 0">
                            <el-checkbox v-for="user in bidderUserList" :key="user.userId" :label="user.userId"
                                style="margin-right: 15px; margin-bottom: 8px;">
                                {{ user.userName }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <div v-if="selectedBidders.length === 0" style="color: #999; font-size: 12px; margin-top: 5px;">
                            请至少选择一个投标单位
                        </div>
                    </div>
                    <div style="margin-top: 12px; text-align: left;">
                        <div style="margin-bottom: 8px; display: flex; align-items: center; gap: 8px;">
                            <span>时间间隔:</span>
                            <el-input-number v-model="timeInterval" :min="0" :step="1" size="small"
                                v-if="countdown == 0" />
                            <div v-else>{{ timeInterval }}</div>
                            <span>分钟</span>
                            <span>剩余时间:<span style="color: red;">{{ formattedCountdown }}</span> </span>
                        </div>
                        <el-checkbox v-model="isUpload" style="margin-top: 10px;"
                            v-if="countdown == 0">勾选后投标人必须上传附件</el-checkbox>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="secondQuoteDialogVisible = false">关闭</el-button>
                        <el-button type="primary" @click="confirmSecondQuote" v-if="countdown == 0">确定</el-button>
                    </span>
                </el-dialog>
                <!-- 查看报价弹窗 -->
                <el-dialog title="查看报价" :visible.sync="viewOfferDialogVisible" width="90%"
                    :close-on-click-modal="false">
                    <template v-if="viewOfferList && viewOfferList.length">
                        <div style="overflow-x: auto; max-height: 600px;">
                            <el-table :data="formattedOfferTableData" border style="min-width: 100%;"
                                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold', textAlign: 'center' }">
                                <!-- 第一列：报价项目 -->
                                <el-table-column label="报价项目" prop="itemName" min-width="150" fixed="left"
                                    align="center">
                                    <template slot-scope="scope">
                                        <span style="font-weight: bold;">{{ scope.row.itemName }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 第二列：单位名称 -->
                                <el-table-column label="单位名称" prop="userName" min-width="150" fixed="left"
                                    align="center">
                                    <template slot-scope="scope">
                                        <span style="color: #409EFF; font-weight: bold;">{{ scope.row.userName }}</span>
                                    </template>
                                </el-table-column>
                                <!-- 动态列：各版本报价 -->
                                <el-table-column v-for="version in allVersions" :key="version"
                                    :label="'第' + version + '次报价'" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.priceByVersion[version]"
                                            style="color: #303133; font-weight: 500;">
                                            {{ scope.row.priceByVersion[version] }}
                                        </span>
                                        <span v-else style="color: #C0C4CC;">-</span>
                                    </template>
                                </el-table-column>
                                <!-- 最后一列：废除按钮 -->
                                <el-table-column label="操作" width="100" fixed="right" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="mini" @click="handleAbolishOffer(scope.row)">
                                            废除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                    <div v-else style="text-align: center; padding: 40px 0; color: #999;">
                        <i class="el-icon-info" style="font-size: 48px; margin-bottom: 10px;"></i>
                        <p>暂无报价数据</p>
                    </div>

                    <span slot="footer" class="dialog-footer">
                        <el-button @click="viewOfferDialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>
                <!-- 二次报价废除弹窗 -->
                <el-dialog title="二次报价废除" :visible.sync="invalidOfferDialogVisible" width="700px"
                    :close-on-click-modal="false">
                    <div v-if="invalidOfferList.length > 0">
                        <el-table :data="invalidOfferList" border stripe style="width: 100%"
                            :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }">
                            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                            <el-table-column prop="userName" label="投标单位" min-width="200">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.userName || '未知单位' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" @click="handleInvalidOffer(scope.row)">
                                        废除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else style="text-align: center; padding: 40px 0; color: #999;">
                        <i class="el-icon-info" style="font-size: 48px; margin-bottom: 10px;"></i>
                        <p>暂无投标单位数据</p>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="invalidOfferDialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>
                <!-- 招标文件澄清及附件弹窗 -->
                <el-dialog title="招标文件澄清及附件" :visible.sync="clarificationDialogVisible" width="800px"
                    :before-close="handleClarificationDialogClose" class="attachment-dialog">
                    <div class="attachment-dialog-content">
                        <!-- 澄清分类标签页 -->
                        <el-tabs v-model="activeClarificationTab" class="attachment-tabs">
                            <!-- 文件澄清内容标签页 -->
                            <el-tab-pane label="文件澄清内容" name="clarificationContent">
                                <div class="attachment-section">
                                    <div class="section-header">
                                        <span class="section-title">文件澄清内容</span>
                                    </div>
                                    <div class="content-display">
                                        <div v-if="clarificationData.content" class="content-text">
                                            {{ clarificationData.content }}
                                        </div>
                                        <div v-else class="no-data">暂无澄清内容</div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <!-- 文件所带附件标签页 -->
                            <el-tab-pane label="文件所带附件" name="clarificationAttachments">
                                <div class="attachment-section">
                                    <div class="section-header">
                                        <span class="section-title">文件所带附件</span>
                                    </div>
                                    <el-table :data="clarificationData.attachments" border stripe
                                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                        :cell-style="{ color: '#303133' }" class="attachment-table">
                                        <el-table-column prop="no" label="NO." width="80" align="center">
                                            <template slot-scope="scope">
                                                {{ scope.$index + 1 }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="200">
                                            <template slot-scope="scope">
                                                <el-link v-if="scope.row.fileName" type="primary"
                                                    @click="handleFileDownload(scope.row)" class="file-link">
                                                    {{ scope.row.fileName }}
                                                </el-link>
                                                <span v-else class="no-data">暂无数据</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleClarificationDialogClose">关闭</el-button>
                    </div>
                </el-dialog>
                <!-- 招标文件补遗及附件弹窗 -->
                <el-dialog title="招标文件补遗及附件" :visible.sync="supplementDialogVisible" width="800px"
                    :before-close="handleSupplementDialogClose" class="attachment-dialog">
                    <div class="attachment-dialog-content">
                        <!-- 补遗分类标签页 -->
                        <el-tabs v-model="activeSupplementTab" class="attachment-tabs">
                            <!-- 文件补遗内容标签页 -->
                            <el-tab-pane label="文件补遗内容" name="supplementContent">
                                <div class="attachment-section">
                                    <div class="section-header">
                                        <span class="section-title">文件补遗内容</span>
                                    </div>
                                    <div class="content-display">
                                        <div v-if="clarificationData.content" class="content-text">
                                            {{ clarificationData.content }}
                                        </div>
                                        <div v-else class="no-data">暂无补遗内容</div>
                                    </div>
                                </div>
                            </el-tab-pane>

                            <!-- 文件所带附件标签页 -->
                            <el-tab-pane label="文件所带附件" name="supplementAttachments">
                                <div class="attachment-section">
                                    <div class="section-header">
                                        <span class="section-title">文件所带附件</span>
                                    </div>
                                    <el-table :data="clarificationData.attachments" border stripe
                                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                        :cell-style="{ color: '#303133' }" class="attachment-table">
                                        <el-table-column prop="no" label="NO." width="80" align="center">
                                            <template slot-scope="scope">
                                                {{ scope.$index + 1 }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fileName" label="文件名称(点击下载)" min-width="200">
                                            <template slot-scope="scope">
                                                <el-link v-if="scope.row.fileName" type="primary"
                                                    @click="handleFileDownload(scope.row)" class="file-link">
                                                    {{ scope.row.fileName }}
                                                </el-link>
                                                <span v-else class="no-data">暂无数据</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleSupplementDialogClose">关闭</el-button>
                    </div>
                </el-dialog>
                <!-- 文件对比 l-drawer -->
                <el-drawer title="文件对比" :visible.sync="drawer2" :direction="direction"
                    :before-close="handleFileComparisonDialogClose" size="100%">
                    <div class="drawer-content" style="padding: 0 10px; display: flex; height: calc(100vh - 120px);">
                        <div class="drawer-content-right"
                            style="text-align: start; display: flex; flex-direction: column; flex: 1; overflow: hidden;">
                            <div style="padding: 8px 0;">
                                <el-button-group>
                                    <el-button :type="leftDocType === '招标文件' ? 'primary' : 'default'" size="mini"
                                        @click="setActiveDocType('招标文件', 'left')">招标文件</el-button>
                                    <el-button :type="leftDocType === '投标文件' ? 'primary' : 'default'" size="mini"
                                        @click="setActiveDocType('投标文件', 'left')">投标文件</el-button>
                                </el-button-group>
                            </div>
                            <div style="display: flex; flex: 1; min-height: 0;">
                                <div v-if="leftDocType === '投标文件'" style=" width: 200px;">
                                    <div style="margin: 6px 0;">
                                        <el-select v-model="leftUserId" placeholder="选择投标人" class="project-select"
                                            @change="getBidderFile(leftUserId, 'left')">
                                            <el-option :label="item.userName" :value="item.userId"
                                                v-for="item in bidderList" :key="item.userId"></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 附件 -->
                                    <div style="display: flex;">
                                        <el-button type="text" size="small"
                                            @click="openAttachmentView('left')">附件内容(查看)</el-button>
                                    </div>
                                    <div class="chapter-tree">
                                        <el-tree :data="catalogueList"
                                            :props="{ label: 'catalogueName', children: 'children' }" node-key="strId"
                                            :default-expanded-keys="defaultExpandedKeys" highlight-current
                                            @node-click="handleLeftCatalogueClick">
                                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                                <span>{{ data.catalogueName }}</span>
                                                <span class="page-num">P{{ data.pageNum }}</span>
                                            </span>
                                        </el-tree>
                                    </div>
                                </div>
                                <div style="flex: 1; min-width: 0; height: 100%; overflow: auto;">
                                    <PdfViewer ref="leftPdfViewer" :pdf-url="leftPdfUrl" :show-toolbar="true"
                                        :initial-scale="1.0" @pdf-loaded="onPdfLoaded" @pdf-error="onPdfError"
                                        @page-changed="onPageChanged" @scale-changed="onScaleChanged" />
                                </div>
                            </div>
                        </div>
                        <div class="drawer-content-right"
                            style="text-align: start; display: flex; flex-direction: column; flex: 1; overflow: hidden; margin: 0px 30px ;">
                            <div style="padding: 8px 0;">
                                <el-button-group>
                                    <el-button :type="rightDocType === '招标文件' ? 'primary' : 'default'" size="mini"
                                        @click="setActiveDocType('招标文件', 'right')">招标文件</el-button>
                                    <el-button :type="rightDocType === '投标文件' ? 'primary' : 'default'" size="mini"
                                        @click="setActiveDocType('投标文件', 'right')">投标文件</el-button>
                                </el-button-group>
                            </div>
                            <div style="display: flex; flex: 1; min-height: 0;">
                                <div v-if="rightDocType === '投标文件'" style=" width: 200px;">
                                    <div style="margin: 6px 0;">
                                        <el-select v-model="rightUserId" placeholder="选择投标人" class="project-select"
                                            @change="getBidderFile(rightUserId, 'right')">
                                            <el-option :label="item.userName" :value="item.userId"
                                                v-for="item in bidderList" :key="item.userId"></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 附件 -->
                                    <div style="display: flex;">
                                        <el-button type="text" size="small"
                                            @click="openAttachmentView('right')">附件内容(查看)</el-button>
                                    </div>
                                    <div class="chapter-tree">
                                        <el-tree :data="catalogueList"
                                            :props="{ label: 'catalogueName', children: 'children' }" node-key="strId"
                                            :default-expanded-keys="defaultExpandedKeys" highlight-current
                                            @node-click="handleRightCatalogueClick">
                                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                                <span>{{ data.catalogueName }}</span>
                                                <span class="page-num">P{{ data.pageNum }}</span>
                                            </span>
                                        </el-tree>
                                    </div>
                                </div>
                                <PdfViewer ref="rightPdfViewer" :pdf-url="rightPdfUrl" :show-toolbar="true"
                                    :initial-scale="1.0" @pdf-loaded="onPdfLoaded" @pdf-error="onPdfError"
                                    @page-changed="onPageChanged" @scale-changed="onScaleChanged" />
                            </div>
                        </div>
                    </div>
                </el-drawer>
                <!-- 开标记录弹窗 -->
                <el-dialog title="开标记录" :visible.sync="bidOpeningDialogVisible" width="800px"
                    :before-close="handleBidOpeningDialogClose">
                    <div v-html="openingRecordContent" class="content-viewer"></div>
                </el-dialog>
                <!-- 招标文件列表弹窗（澄清/补遗通用） -->
                <el-dialog title="招标文件列表" :visible.sync="documentListDialogVisible" width="50%">
                    <el-table :data="documentListData" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                        :cell-style="{ color: '#303133' }">
                        <el-table-column prop="bidInvitationDocumentsCode" label="招标文件编号" align="center" />
                        <el-table-column prop="bidInvitationDocumentsName" label="招标文件名称" />
                        <el-table-column prop="createTime" label="创建时间" align="center" />
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleDocumentDetail(scope.row)">
                                    详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="documentListDialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>

                <!-- 废除理由弹窗 -->
                <el-dialog title="废除报价" :visible.sync="abolishReasonDialogVisible" width="500px"
                    :close-on-click-modal="false">
                    <div class="abolish-reason-content">
                        <div class="abolish-info">
                            <p><strong>项目名称：</strong>{{ abolishOfferInfo.itemName }}</p>
                            <p><strong>投标单位：</strong>{{ abolishOfferInfo.userName }}</p>
                        </div>
                        <el-form :model="abolishForm" :rules="abolishRules" ref="abolishForm" label-width="100px">
                            <el-form-item label="废除理由:" prop="reason">
                                <el-input type="textarea" v-model="abolishForm.reason" :rows="4" placeholder="请输入废除理由"
                                    maxlength="500" show-word-limit>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="abolishReasonDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleConfirmAbolish"
                            :loading="abolishSubmitting">确定</el-button>
                    </div>
                </el-dialog>

                <!-- 计算基准价弹窗 -->
                <el-dialog title="计算基准价" :visible.sync="benchmarkPriceDialogVisible" width="80%"
                    :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
                    <div class="benchmark-price-content">
                        <!-- 标题栏 -->
                        <div class="dialog-header">
                            <div class="header-left">
                                <h3 class="dialog-title">计算基准价</h3>
                            </div>
                            <div class="header-right">
                                <el-button type="primary" class="close-btn"
                                    @click="handleBenchmarkPriceDialogClose">关闭</el-button>
                            </div>
                        </div>
                        <!-- 投标单位信息表格 -->
                        <div class="bidder-table-container">
                            <el-table :data="benchmarkPriceData.bidders" border style="width: 100%"
                                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                :cell-style="{ color: '#303133' }" class="benchmark-price-table">
                                <!-- 投标单位名称列 -->
                                <el-table-column prop="userName" label="投标单位名称" min-width="200" align="center">
                                    <template slot-scope="scope">
                                        <span class="company-name">{{ scope.row.userName }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 投标单位编码列 -->
                                <el-table-column prop="userId" label="投标单位编码" min-width="180" align="center">
                                    <template slot-scope="scope">
                                        <span class="company-code">{{ scope.row.userId || '-' }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 报价列 -->
                                <el-table-column prop="price" label="报价(元)" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span class="quote-amount">{{ scope.row.price }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <!-- 计算规则说明 -->
                        <div class="calculation-rules" v-if="basePriceDesLines.length != 0">
                            <h4 class="rules-title">计算规则说明：</h4>
                            <div class="rules-content">
                                <p v-for="(line, idx) in basePriceDesLines" :key="idx">{{ idx + 1 }} 、{{ line }}</p>
                            </div>
                        </div>

                        <!-- 计算结果区域 -->
                        <div class="calculation-result">
                            <div class="result-content">
                                <div class="result-item">
                                    <label class="result-label">计算基准价为：(元)</label>
                                    <el-input v-model="benchmarkPriceData.price" type="number" class="result-input"
                                        :disabled="benchmarkPriceData.status != 1 || role != '1'"></el-input>
                                </div>

                                <!-- <div class="result-item">
                                    <label class="result-label">基准价浮动比例：</label>
                                    <el-input-number v-model="rate" type="number" controls-position="right" :min="0"
                                        :max="100" class="fluctuation-input">
                                    </el-input-number>
                                    <span class="percentage-symbol">%</span>
                                </div> -->
                                <div class="calculate-button-container" v-if="role == '1'">
                                    <el-button type="success" @click="handleCalculateBenchmarkPrice"
                                        class="calculate-btn" :disabled="evaluationStatus == 2">
                                        {{ benchmarkPriceData.status == 1 ? '保存' : '计算' }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
                <!-- 计算报价得分弹窗 -->
                <el-dialog title="计算结果" :visible.sync="bidScoreDialogVisible" width="70%"
                    custom-class="bid-score-dialog">
                    <div class="bid-score-content">
                        <!-- 投标单位信息表格 -->
                        <div class="bidder-table-container">
                            <el-table :data="bidScoreData" border style="width: 100%"
                                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                :cell-style="{ color: '#303133' }" class="bid-score-table">

                                <!-- 投标单位名称列 -->
                                <el-table-column prop="userName" label="投标单位名称" min-width="200" align="center">
                                    <template slot-scope="scope">
                                        <span class="company-name">{{ scope.row.userName }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 投标单位编码列 -->
                                <el-table-column prop="userId" label="投标单位编码" min-width="180" align="center">
                                    <template slot-scope="scope">
                                        <span class="company-code">{{ scope.row.userId || '-' }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 投标单位报价列 -->
                                <el-table-column prop="price" label="投标单位报价(元)" min-width="150" align="center">
                                    <template slot-scope="scope">
                                        <span class="bid-price">{{ scope.row.price }}</span>
                                    </template>
                                </el-table-column>

                                <!-- 报价得分列 -->
                                <el-table-column prop="score" label="报价得分" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="quotationData.manCalculate !== 1 || role != '1'"
                                            class="score-value">{{
                                                scope.row.score }}</span>
                                        <el-input-number v-else-if="quotationData.manCalculate == 1 && role == '1'"
                                            v-model="scope.row.score" :min="0" :step="0.01" size="small" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- 计算规则说明 -->
                        <div class="calculation-rules" v-if="quotationData.description">
                            <h4 class="rules-title">报价得分计算规则：</h4>
                            <div class="rules-content">
                                <p>{{ quotationData.description }}</p>
                            </div>
                        </div>
                        <!-- 计算按钮 -->
                        <div class="calculate-button-container" v-if="role == '1'">
                            <el-button type="primary" @click="handleCalculateBidScore" class="calculate-btn"
                                :disabled="evaluationStatus == 2">
                                {{ quotationData.manCalculate == 1 ? '保存' : '计算' }}
                            </el-button>
                        </div>
                    </div>
                </el-dialog>

                <!-- 推荐中标候选人弹窗 -->
                <el-dialog title="中标候选人" :visible.sync="winnerCandidateDialogVisible" width="90%"
                    :close-on-click-modal="false">
                    <div class="winner-candidate-content">
                        <!-- 表格区域 -->
                        <div class="candidate-table-container">
                            <el-table :data="winnerCandidateData" class="winner-candidate-table" border>
                                <el-table-column prop="rank" label="排名" width="200" align="center" fixed>
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.rank" :min="0"
                                            :max="winnerCandidateData.length" size="small" controls-position="right"
                                            :disabled="viewCandidateDialogVisible || role != '1'">
                                        </el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="userName" label="投标单位名称" min-width="200" fixed>
                                    <template slot-scope="scope">
                                        <span class="company-name">{{ scope.row.userName }}</span>
                                    </template>
                                </el-table-column>

                                <el-table-column v-for="col in winnerPriceColumns" :key="col.prop" :prop="col.prop"
                                    :label="col.label" width="120" align="center">
                                    <template slot-scope="scope">
                                        <span class="final-price">{{ scope.row[col.prop] }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="basePrice" label="计算基准价" align="center">
                                    <template slot-scope="scope">
                                        <span class="base-price">{{ scope.row.basePrice }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="col in winnerQuoteColumns" :key="col.prop" :prop="col.prop"
                                    :label="col.label" width="120" align="center">
                                    <template slot-scope="scope">
                                        <span class="quote-score">{{ scope.row[col.prop] }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="col in winnerScoreColumns" :key="col.prop" :prop="col.prop"
                                    :label="col.label" width="140" align="center">
                                    <template slot-scope="scope">
                                        <span class="marking-score">{{ scope.row[col.prop] }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalScore" label="总分" width="120" align="center">
                                    <template slot-scope="scope">
                                        <span class="total-score" style="font-weight: bold; color: #409EFF;">{{
                                            scope.row.totalScore }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- 调整原因输入区域 -->
                        <div class="adjustment-reason-container">
                            <div class="reason-label">调整原因:</div>
                            <el-input v-model="adjustmentReason" type="textarea" :rows="3" placeholder="请输入调整原因"
                                class="reason-input" :disabled="viewCandidateDialogVisible || role != '1'">
                            </el-input>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleWinnerCandidateDialogClose">{{ viewCandidateDialogVisible || role !=
                            '1' ? '关闭' : '取消'
                        }}</el-button>
                        <el-button v-if="!viewCandidateDialogVisible && role == '1'" type="primary"
                            @click="handleSaveWinnerCandidate" :disabled="evaluationStatus == 2">保存</el-button>
                    </div>
                </el-dialog>
                <!-- 异常行为识别弹窗 -->
                <el-dialog title="显示异常行为分析" :visible.sync="abnormalBehaviorDialogVisible" width="90%"
                    :before-close="handleAbnormalBehaviorDialogClose" class="abnormal-behavior-dialog">
                    <div class="abnormal-behavior-content">
                        <el-table :data="abnormalBehaviorData" style="width: 100%" border stripe>
                            <el-table-column prop="no" label="NO." width="60" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="userName" label="单位名称" width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span
                                        :class="scope.row.userName && scope.row.userName.endsWith && scope.row.userName.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.userName ? scope.row.userName.replace(/异常$/, '') : '-' }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invitationDownloadIp" label="招标文件下载ip" width="140" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.invitationDownloadIp"
                                        :class="scope.row.invitationDownloadIp && scope.row.invitationDownloadIp.endsWith && scope.row.invitationDownloadIp.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.invitationDownloadIp.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invitationDownloadTime" label="招标文件下载时间" width="180" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.invitationDownloadTime"
                                        :class="scope.row.invitationDownloadTime && scope.row.invitationDownloadTime.endsWith && scope.row.invitationDownloadTime.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.invitationDownloadTime.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="bidUploadIp" label="投标文件递交ip" width="140" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.bidUploadIp"
                                        :class="scope.row.bidUploadIp && scope.row.bidUploadIp.endsWith && scope.row.bidUploadIp.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.bidUploadIp.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="bidUploadTime" label="投标文件递交时间" width="180" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.bidUploadTime"
                                        :class="scope.row.bidUploadTime && scope.row.bidUploadTime.endsWith && scope.row.bidUploadTime.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.bidUploadTime.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="decryptIp" label="解密ip" width="140" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.decryptIp"
                                        :class="scope.row.decryptIp && scope.row.decryptIp.endsWith && scope.row.decryptIp.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.decryptIp.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mac" label="mac地址" width="300" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.mac"
                                        :class="scope.row.mac && scope.row.mac.endsWith && scope.row.mac.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.mac.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fileId" label="文件创建标识码" width="200" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.fileId"
                                        :class="scope.row.fileId && scope.row.fileId.endsWith && scope.row.fileId.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.fileId.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contacts" label="项目联系人" width="120" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.contacts"
                                        :class="scope.row.contacts && scope.row.contacts.endsWith && scope.row.contacts.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.contacts.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone" label="联系电话" width="140" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.phone"
                                        :class="scope.row.phone && scope.row.phone.endsWith && scope.row.phone.endsWith('异常') ? 'highlight-red' : ''">
                                        {{ scope.row.phone.replace(/异常$/, '') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="重复预警标识" width="200" align="center">
                                <template slot-scope="scope">
                                    <div class="warning-tags">
                                        <el-tag
                                            v-for="tag in (scope.row.remark ? scope.row.remark.split(/[,，]/).filter(t => t && t.trim()) : [])"
                                            :key="tag" type="danger" size="mini" class="warning-tag"
                                            :class="tag.endsWith && tag.endsWith('异常') ? 'highlight-red' : ''">
                                            {{ tag }}
                                        </el-tag>
                                        <span v-if="!scope.row.remark">-</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-dialog>
                <!-- 评标流程终止弹窗 -->
                <el-dialog title="评标流程终止" :visible.sync="processTerminationDialogVisible" width="60%"
                    :before-close="handleProcessTerminationDialogClose" class="process-termination-dialog">
                    <div class="process-termination-content">
                        <!-- 文本输入区域 -->
                        <div class="text-input-section">
                            <el-input type="textarea" v-model="terminationReason" placeholder="请输入内容" :rows="2"
                                class="termination-textarea" resize="vertical">
                            </el-input>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" style="border: 1px solid  white;">
                        <el-button @click="handleProcessTerminationDialogClose">取消</el-button>
                        <el-button type="primary" @click="handleConfirmTermination" class="submit-btn"
                            :disabled="evaluationStatus == 2">提交</el-button>
                    </div>
                </el-dialog>
                <!-- 调整投标单位报价弹窗 -->
                <el-dialog title="调整投标单位报价" :visible.sync="priceAdjustmentDialogVisible" width="80%"
                    :before-close="handlePriceAdjustmentDialogClose" class="price-adjustment-dialog">
                    <div class="price-adjustment-content">
                        <!-- 调整历史表格 -->
                        <div class="adjustment-history-section">
                            <div class="section-title">调整历史</div>
                            <div style="overflow-x: auto;">
                                <el-table :data="adjustmentHistoryData" border stripe
                                    :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                    :cell-style="{ color: '#303133' }" class="adjustment-history-table">
                                    <!-- 第一列：NO. -->
                                    <el-table-column prop="no" label="NO." width="80" fixed="left" align="center">
                                        <template slot-scope="scope">
                                            <span class="highlight-red">{{ scope.$index + 1 }}</span>
                                        </template>
                                    </el-table-column>
                                    <!-- 第二列：投标单位名称 -->
                                    <el-table-column prop="userName" label="投标单位名称" min-width="180" fixed="left"
                                        align="left"></el-table-column>
                                    <!-- 动态列：各报价项目的调整前(调整后)价格 -->
                                    <el-table-column v-for="column in historyPriceItemColumns" :key="column.itemKey"
                                        :label="column.itemName" min-width="150" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.priceMap && scope.row.priceMap[column.itemKey]"
                                                style="color: #303133;">
                                                {{ scope.row.priceMap[column.itemKey] }}
                                            </span>
                                            <span v-else style="color: #C0C4CC;">-</span>
                                        </template>
                                    </el-table-column>
                                    <!-- 第四列：调整原因 -->
                                    <el-table-column prop="adjustReason" label="调整原因" min-width="200" fixed="left"
                                        align="left"></el-table-column>

                                    <!-- 第三列：调整时间 -->
                                    <el-table-column prop="adjustTime" label="调整时间" min-width="160" fixed="left"
                                        align="center"></el-table-column>

                                </el-table>
                            </div>
                        </div>
                        <!-- 投标单位详情和调整表格 -->
                        <div class="bid-units-section">
                            <div class="section-title">投标单位详情</div>
                            <div style="overflow-x: auto;">
                                <el-table :data="bidUnitsData" border stripe
                                    :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                    :cell-style="{ color: '#303133' }" class="bid-units-table">
                                    <!-- 第一列：投标单位名称 -->
                                    <el-table-column prop="userName" label="投标单位名称" min-width="200" fixed="left"
                                        align="left"></el-table-column>
                                    <!-- 第二列：投标单位编码 -->
                                    <el-table-column prop="userId" label="投标单位编码" min-width="250" fixed="left"
                                        align="center"></el-table-column>
                                    <!-- 动态列：各报价项目 -->
                                    <el-table-column v-for="column in priceItemColumns" :key="column.itemKey"
                                        :label="column.itemName" min-width="150" align="center">
                                        <template slot-scope="scope">
                                            <div class="price-input-container">
                                                <el-input-number v-model="scope.row.priceMap[column.itemKey]" :min="0"
                                                    controls-position="right" size="small" class="price-input">
                                                </el-input-number>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <!-- 调整原因输入 -->
                        <div class="adjustment-reason-section">
                            <div class="reason-label">
                                <span class="required-asterisk">*</span>
                                <span class="label-text">调整原因:</span>
                            </div>
                            <el-input v-model="adjustmentReason" type="textarea" :rows="2" placeholder="请输入调整原因"
                                class="reason-textarea">
                            </el-input>
                        </div>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" class="confirm-btn" @click="handleConfirmAdjustment"
                            :disabled="evaluationStatus == 2">确认调整</el-button>
                    </div>
                </el-dialog>
                <!-- 形式评审标准弹窗 -->
                <el-dialog title="" :visible.sync="formalReviewDialogVisible" width="100%" height="100%"
                    :before-close="handleFormalReviewDialogClose" class="formal-review-dialog" :modal="true"
                    :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="formal-review-content">
                        <!-- 标题栏 -->
                        <div class="formal-review-header">
                            <div class="header-left">
                                <h1 class="review-title">形式评审标准</h1>
                            </div>
                            <div class="header-right">
                                <el-button type="primary" class="one-click-pass-btn" @click="handleOneClickPass"
                                    :disabled="evaluationStatus == 2">一键通过</el-button>
                                <el-button type="primary" class="close-btn"
                                    @click="handleFormalReviewDialogClose">关闭</el-button>
                                <el-button type="primary" class="submit-effective-btn" @click="handleSubmitEffective"
                                    :disabled="evaluationStatus == 2">提交生效</el-button>
                            </div>
                        </div>

                        <!-- 评审表格 -->
                        <div class="review-table-container">
                            <el-table :data="formalReviewData" border style="width: 100%"
                                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266', fontWeight: 'bold' }"
                                :cell-style="{ color: '#303133' }" class="formal-review-table">

                                <!-- 投标单位列 -->
                                <el-table-column prop="companyName" label="投标单位" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <div class="company-cell">
                                            <span class="company-name">{{ scope.row.companyName }}</span>
                                            <el-button type="primary" size="mini" class="pass-all-btn"
                                                @click="handlePassAllForCompany(scope.row)"
                                                :disabled="evaluationStatus == 2">全通过</el-button>
                                        </div>
                                    </template>
                                </el-table-column>

                                <!-- 投标人名称列 -->
                                <el-table-column prop="bidderName" label="投标人名称" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.bidderNameResult"
                                            @change="handleReviewChange(scope.row, 'bidderName')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 投标函及投标函附录签字盖章列 -->
                                <el-table-column prop="signatureSeal" label="投标函及投标函附录签字盖章" min-width="120"
                                    align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.signatureSealResult"
                                            @change="handleReviewChange(scope.row, 'signatureSeal')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 投标文件格式列 -->
                                <el-table-column prop="documentFormat" label="投标文件格式" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.documentFormatResult"
                                            @change="handleReviewChange(scope.row, 'documentFormat')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 联合体投标人（适用）列 -->
                                <el-table-column prop="consortiumBidder" label="联合体投标人（适用）" min-width="120"
                                    align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.consortiumBidderResult"
                                            @change="handleReviewChange(scope.row, 'consortiumBidder')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 备选投标方案列 -->
                                <el-table-column prop="alternativeProposal" label="备选投标方案" min-width="120"
                                    align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.alternativeProposalResult"
                                            @change="handleReviewChange(scope.row, 'alternativeProposal')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 报价唯一列 -->
                                <el-table-column prop="singleQuote" label="报价唯一" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.singleQuoteResult"
                                            @change="handleReviewChange(scope.row, 'singleQuote')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>

                                <!-- 其他列 -->
                                <el-table-column prop="other" label="其他" min-width="120" align="center">
                                    <template slot-scope="scope">
                                        <el-radio-group v-model="scope.row.otherResult"
                                            @change="handleReviewChange(scope.row, 'other')">
                                            <el-radio :label="true">
                                                <span class="radio-symbol">✓</span>
                                            </el-radio>
                                            <el-radio :label="false">
                                                <span class="radio-symbol">×</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-dialog>
                <!-- 评审报告抽屉 -->
                <el-drawer title="查看评审报告" :visible.sync="reportDialogVisible" size="90%"
                    :before-close="closeReportDialog">
                    <div class="drawer-content">
                        <!-- 左侧文件列表 + 按钮 -->
                        <div class="drawer-content-left report-file-list">
                            <div class="chapter-tree">
                                <div v-for="(file, index) in reportFileList" :key="file.fileId" class="report-file-item"
                                    :class="{ 'is-active': currentFileIndex === index }"
                                    @click="handleFileSelect(file, index)">
                                    <span :title="file.fileName">{{ file.fileName }}</span>
                                </div>
                                <div v-if="reportFileList.length === 0" class="report-file-empty">
                                    暂无文件
                                </div>
                            </div>
                            <!-- 操作按钮放在左侧底部 -->
                            <div class="report-drawer-footer">
                                <el-button size="small" @click="closeReportDialog">{{ reportSubmitted ? '关闭' : '取消'
                                }}</el-button>
                                <el-button v-if="signed == 0" size="small" type="primary"
                                    @click="submitReport">签字</el-button>
                            </div>
                        </div>
                        <!-- 右侧PDF预览 -->
                        <div class="drawer-content-right">
                            <div class="pdf-viewer-container">
                                <div style="flex: 1; min-width: 0; height: 100%; overflow: auto;">
                                    <PdfViewer v-if="reportPdfUrl" :pdf-url="reportPdfUrl" :show-toolbar="true"
                                        :initial-scale="1.0" @pdf-loaded="onReportPdfLoaded"
                                        @pdf-error="onReportPdfError" @page-changed="onReportPageChanged"
                                        @scale-changed="onReportScaleChanged" />
                                    <div v-else class="report-pdf-empty">
                                        <i class="el-icon-document"></i>
                                        <p>请在左侧选择文件</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-drawer>
                <!-- 选择证书弹窗 -->
                <el-dialog title="选择证书" :visible.sync="passwordDialogVisible" width="400px"
                    :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" class="password-dialog">
                    <div class="password-dialog-content">
                        <div class="password-input-section">
                            <el-select v-model="selectedCert" placeholder="请选择证书" style="width: 100%;" :popper-append-to-body="false">
                                <el-option v-for="item in certList" :key="item.signCertSn" :label="item.appName"
                                    :value="item.signCertSn">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancelPassword">取消</el-button>
                        <el-button type="primary" @click="confirmPassword">确定</el-button>
                    </div>
                </el-dialog>

                <!-- 聊天窗口组件 -->
                <ChatWindow :visible="chatWindowVisible" :position="chatWindowPosition" :current-user="currentUser"
                    :chat-group-list="chatGroupList" :chat-messages="chatMessages" :default-group="selectedGroup"
                    @close="handleChatWindowClose" @position-change="handleChatPositionChange"
                    @send-message="handleSendMessage" @group-selected="handleGroupSelected" />
            </div>
        </template>
<script>
import PdfViewer from '@/components/common/PdfViewer.vue'
import ChatWindow from '@/components/common/ChatWindow.vue'
import Cookies from 'js-cookie'
import { invalidOffersGet, evaluationEndQuery, evaluationEndUpdate, getReportFile, expertSign, getExpertCertList, getBidderList, getBidderFile, getBidCatalogue, getEvaluationAgentContent, terminate, getOfferConfigList, saveOfferConfig, getStepList, createStepRecord, getStepMesList, saveStepMse, getStepQuotationList, inputStepQuotation, calculateStepQuotation, getBasePriceDes, saveBasePrice, getRecommendList, calculateBasePrice, rankUpdate } from '@/api/evaluation/api'
import { getInvitationMain, getInvitationAttList, getEvaluationAgentFile } from '@/api/make/api'
import { getOpeningRecordDetail, getOfferList, getAdjust, getAnomalousList, invalidOffer, getClarificationList } from '@/api/agent/api'
import { getOfferListForEvaluation, subscribeExpertScore } from '@/api/offer/api'
import { getProjectInfo } from '@/api/bidEvaluationCommittee/api'
import { getExpertGroupList, sendMessage, getChatList } from '@/api/chat/api'
import MQTT from '@/utils/mqtt'
import { mqttUrl } from '@/utils/base.js'
export default {
    name: 'EvaluationPage',
    components: {
        PdfViewer,
        ChatWindow
    },
    data() {
        return {
            invalidOfferid: '',//二次报价废除用到的
            // 废除理由弹窗相关
            abolishReasonDialogVisible: false,
            abolishOfferInfo: {
                itemName: '',
                userName: '',
                userId: ''
            },
            abolishForm: {
                reason: ''
            },
            abolishRules: {
                reason: [
                    { required: true, message: '请输入废除理由', trigger: 'blur' },
                    { min: 5, message: '废除理由至少5个字符', trigger: 'blur' }
                ]
            },
            abolishSubmitting: false,
            signed: 0,
            stepId: 0,
            evaluationStatus: 0,//是否结束 0：为开始 1：进行中。2：结束
            showEvaluationEndButton: false,
            quotationData: {},
            sectionCode: Cookies.get('bidSectionCode'),
            role: Cookies.get('role'),//1 组长 其他组员
            title: Cookies.get('title'),//顶部名称
            bidderList: [],  // 投标单位列表
            userId: "", // 选择的用户ID
            leftUserId: "", // 左侧文件对比选择的用户ID
            rightUserId: "", // 右侧文件对比选择的用户ID
            catalogueList: [], // 章节目录列表
            defaultExpandedKeys: [], // 默认展开的节点
            basePdfUrl: '', // 公共的PDF URL
            reportPdfUrl: '', // 评审报告PDF URL
            // 评审报告抽屉相关
            reportDialogVisible: false, // 评审报告抽屉显示状态
            reportSubmitted: false, // 评审报告是否已提交
            reportFileList: [], // 文件列表
            currentFileIndex: -1, // 当前选中文件索引
            // 证书选择弹窗相关
            passwordDialogVisible: false, // 证书选择弹窗显示状态
            selectedCert: '', // 选中的证书ID
            certList: [], // 证书列表
            drawer: false,//投标文件弹窗
            drawer1: false,//招标文件弹窗
            drawer2: false,//文件对比弹窗
            drawerTitle: '',
            direction: 'rtl',
            // 开标记录弹窗
            bidOpeningDialogVisible: false,
            openingRecordContent: '',
            // 调整投标单位报价弹窗
            priceAdjustmentDialogVisible: false,
            adjustmentHistoryData: [],
            processTerminationDialogVisible: false,
            terminationReason: '',
            // 计算 基准价描述
            basePriceDesLines: '',

            // 形式评审标准弹窗
            formalReviewDialogVisible: false,
            formalReviewData: [
                {
                    id: 1,
                    companyName: '',
                    bidderName: '',
                    bidderNameResult: true,
                    signatureSealResult: true,
                    documentFormatResult: true,
                    consortiumBidderResult: true,
                    alternativeProposalResult: true,
                    singleQuoteResult: true,
                    otherResult: true
                },
                {
                    id: 2,
                    companyName: '',
                    bidderName: '',
                    bidderNameResult: true,
                    signatureSealResult: true,
                    documentFormatResult: true,
                    consortiumBidderResult: true,
                    alternativeProposalResult: true,
                    singleQuoteResult: true,
                    otherResult: true
                },
                {
                    id: 3,
                    companyName: '',
                    bidderName: '',
                    bidderNameResult: true,
                    signatureSealResult: true,
                    documentFormatResult: true,
                    consortiumBidderResult: true,
                    alternativeProposalResult: true,
                    singleQuoteResult: true,
                    otherResult: true
                }
            ],
            // 计算基准价弹窗
            benchmarkPriceDialogVisible: false,
            benchmarkPriceData: {},
            price: '',
            rate: 100,

            // 计算报价得分弹窗
            bidScoreDialogVisible: false,
            bidScoreData: [],
            benchmarkPriceForScore: 2000, // 评分基准价
            scoreStandardPoints: 100, // 该项标准分

            // 推荐中标候选人弹窗相关
            winnerCandidateDialogVisible: false,
            // 推荐中标候选人数据
            winnerCandidateData: [],
            // 推荐中标候选人价格列配置（由接口的 prices 动态生成）
            winnerPriceColumns: [],
            // 推荐中标候选人报价得分列配置（由接口的 quotes 动态生成）
            winnerQuoteColumns: [],
            // 推荐中标候选人评分项得分列配置（由接口的 scores 动态生成）
            winnerScoreColumns: [],
            adjustmentReason: '', // 调整原因

            // 异常行为识别弹窗
            abnormalBehaviorDialogVisible: false,
            abnormalBehaviorData: [],
            // 调整报价--投标单位列表
            bidUnitsData: [],
            adjustmentReason: '',
            // 招标文件附件弹窗相关
            attachmentDialogVisible: false,
            activeAttachmentTab: '',
            // 按 fileExtension 分组后的附件数据，key 为类型（如 zip、pdf 等）
            attachmentData: {},
            // 附件类型列表（来自接口的 fileExtension 去重）
            attachmentTypes: [],
            // 招标文件澄清及附件弹窗相关
            clarificationDialogVisible: false,
            // 澄清/补遗当前激活的标签页
            activeClarificationTab: 'clarificationContent',
            // 澄清/补遗数据
            clarificationData: {
                content: '',
                attachments: []
            },
            // 招标文件补遗及附件弹窗相关
            supplementDialogVisible: false,
            // 补遗/澄清当前激活的标签页
            activeSupplementTab: 'supplementContent',
            // 招标文件列表弹窗（澄清/补遗共用）
            documentListDialogVisible: false,
            // 澄清/补遗类型
            documentListType: '',
            // 澄清/补遗数据
            documentListData: [],
            // 二次报价清单
            secondQuoteDialogVisible: false,
            secondQuoteList: [],
            // 二次报价 勾选后投标人必须上传附件
            isUpload: false,
            // 投标单位列表
            bidderUserList: [],
            // 选中的投标单位
            selectedBidders: [],
            // 二次报价废除弹窗
            invalidOfferDialogVisible: false,
            // 二次报价废除投标人列表
            invalidOfferList: [],
            selectedOption: '',
            // PDF查看器相关数据
            pdfUrl: '',
            // 文件对比左侧PDF
            leftPdfUrl: '',
            // 文件对比右侧PDF
            rightPdfUrl: '',
            // 文件对比：左右各自文档类型（招标文件/投标文件）
            activeDocType: '招标文件',
            leftDocType: '招标文件',
            rightDocType: '投标文件',
            // 小微企业审核
            microAuditDrawerVisible: false,
            selectedMicroCompany: '',//选中的小微企业
            // 小微企业审核选项
            microAuditCompanyOptions: [],
            // 小微企业审核列表
            microAuditList: [],
            // 附件查看弹窗
            attachmentViewDialogVisible: false,
            // 附件查看列表
            attachmentViewList: [],
            // 评审步骤数据
            reviewStepsData: [],
            // 组长二次报价时间间隔
            timeInterval: 0,
            // 倒计时（秒数）
            countdown: 0,
            // 倒计时定时器
            countdownTimer: null,
            // 是否能编辑
            isEnable: 0,
            // 查看报价：弹窗可见性与列表数据
            viewOfferDialogVisible: false,
            // 查看报价列表
            viewOfferList: [],
            //  查看候选人
            viewCandidateDialogVisible: false,
            //判断是否展示小微企业审核
            hasSmallMicroEnterpriseReview: false,

            // 聊天相关数据
            projectType: '', // 项目类型
            chatWindowVisible: false, // 聊天窗口显示状态
            chatGroupList: [],
            chatMessages: [],
            selectedGroup: null,  // 当前选中的群组
            currentTopic: null,   // 当前 MQTT 主题
            chatWindowPosition: { x: 100, y: 100 },
            currentUser: {
                name: '专家',
                avatar: ''
            }
        }
    },
    computed: {

        // 获取调整历史的报价项目列
        historyPriceItemColumns() {
            if (!this.adjustmentHistoryData || this.adjustmentHistoryData.length === 0) {
                return []
            }

            // 收集所有出现过的项目
            const itemsMap = new Map()
            this.adjustmentHistoryData.forEach(record => {
                if (record.priceList && Array.isArray(record.priceList)) {
                    record.priceList.forEach(item => {
                        if (!itemsMap.has(item.itemKey)) {
                            itemsMap.set(item.itemKey, {
                                itemKey: item.itemKey,
                                itemName: item.itemName
                            })
                        }
                    })
                }
            })

            // 转换为数组并排序
            return Array.from(itemsMap.values()).sort((a, b) => {
                // 总价排第一，其他按 itemKey 排序
                if (a.itemKey === '1') return -1
                if (b.itemKey === '1') return 1
                return parseInt(a.itemKey) - parseInt(b.itemKey)
            })
        },

        // 获取报价项目列（用于调整投标单位报价弹窗）
        priceItemColumns() {
            if (!this.bidUnitsData || this.bidUnitsData.length === 0) {
                return []
            }

            // 从第一个投标单位的 priceItems 中提取所有项目
            const firstBidder = this.bidUnitsData[0]
            if (!firstBidder.priceItems || !Array.isArray(firstBidder.priceItems)) {
                return []
            }

            // 返回项目列表，按 itemKey 排序
            return firstBidder.priceItems.map(item => ({
                itemKey: item.itemKey,
                itemName: item.itemName
            })).sort((a, b) => {
                // 总价排第一，其他按 itemKey 排序
                if (a.itemKey === '1') return -1
                if (b.itemKey === '1') return 1
                return parseInt(a.itemKey) - parseInt(b.itemKey)
            })
        },

        // 获取所有版本号
        allVersions() {
            if (!this.viewOfferList || this.viewOfferList.length === 0) {
                return []
            }

            const versionsSet = new Set()
            this.viewOfferList.forEach(item => {
                if (item.items && Array.isArray(item.items)) {
                    item.items.forEach(priceItem => {
                        if (priceItem.version) {
                            versionsSet.add(priceItem.version)
                        }
                    })
                }
            })

            return Array.from(versionsSet).sort((a, b) => a - b)
        },

        // 格式化报价数据为横向表格
        formattedOfferTableData() {
            if (!this.viewOfferList || this.viewOfferList.length === 0) {
                return []
            }

            // 将数据转换为表格行格式
            // 每个报价项目（itemName）对应一行
            const tableData = []

            this.viewOfferList.forEach(item => {
                const row = {
                    key: item.key,
                    itemName: item.itemName,
                    userId: item.userId,
                    userName: item.userName,
                    priceByVersion: {} // 存储各版本的报价
                }

                // 将 items 数组中的报价按版本号组织
                if (item.items && Array.isArray(item.items)) {
                    item.items.forEach(priceItem => {
                        row.priceByVersion[priceItem.version] = priceItem.price
                    })
                }

                tableData.push(row)
            })

            return tableData
        },

        // 功能卡片配置
        functionCards() {
            const cards = [
                {
                    title: '投标文件',
                    icon: 'el-icon-document-add',
                    drawer: 'drawer'
                },
                {
                    title: '招标文件',
                    icon: 'el-icon-document',
                    drawer: 'drawer1'
                },
                {
                    title: '招标文件附件',
                    icon: 'el-icon-paperclip',
                    dialog: 'attachmentDialogVisible'
                },
                {
                    title: '招标文件澄清及附件',
                    icon: 'el-icon-paperclip',
                    dialog: 'clarificationDialogVisible'
                },
                {
                    title: '招标文件补遗及附件',
                    icon: 'el-icon-paperclip',
                    dialog: 'supplementDialogVisible'
                },
                {
                    title: '文件对比',
                    icon: 'el-icon-document-copy',
                    drawer: 'drawer2'
                },
                {
                    title: '开标记录',
                    icon: 'el-icon-document',
                    dialog: 'bidOpeningDialogVisible'
                },
                {
                    title: '调整投标单位报价',
                    icon: 'el-icon-coin',
                    dialog: 'priceAdjustmentDialogVisible'
                },
                {
                    title: '二次报价废除',
                    icon: 'el-icon-document',
                    action: 'handleSecondaryQuoteAbandon'
                },
                {
                    title: '评标流程终止',
                    icon: 'el-icon-document',
                    dialog: 'processTerminationDialogVisible'
                },
                {
                    title: '异常行为识别',
                    icon: 'el-icon-monitor',
                    dialog: 'abnormalBehaviorDialogVisible'
                }
            ];

            const filteredCards = this.showSecondButtons
                ? cards
                : cards.filter(card => card.title !== '二次报价废除');

            // 非组长隐藏“调整投标单位报价”和“二次报价废除”两个功能卡片
            if (this.role !== '1') {
                return filteredCards.filter(card => !['调整投标单位报价', '二次报价废除', '评标流程终止'].includes(card.title));
            }

            return filteredCards;
        },

        // 格式化倒计时显示 (HH:MM:SS)
        formattedCountdown() {
            const countdownValue = Number(this.countdown) || 0
            if (countdownValue <= 0 || isNaN(countdownValue)) {
                return '00:00:00'
            }
            const hours = Math.floor(countdownValue / 3600)
            const minutes = Math.floor((countdownValue % 3600) / 60)
            const seconds = countdownValue % 60
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        },

        // 功能卡片分行显示
        functionCardsRows() {
            const cardsPerRow = 8;
            const rows = [];
            for (let i = 0; i < this.functionCards.length; i += cardsPerRow) {
                rows.push(this.functionCards.slice(i, i + cardsPerRow));
            }
            return rows;
        },

        // 评标步骤配置
        reviewStepsConfig() {
            return this.reviewStepsData.map(step => ({
                ...step,
                hasReview: ['资格审查', '响应性评审'].includes(step.nodeName),
                hasCalculate: ['计算机基准价', '计算报价得分'].includes(step.nodeName),
                expertNames: step.expertNames,
                hasRecommend: step.nodeName === '推荐中标候选人'
            }));

        },

        filteredReviewStepsConfig() {
            return this.reviewStepsConfig.filter(step => step.stepTypeCode !== '0601' && step.stepTypeCode !== '0602');
        },

        showSecondButtons() {
            if (this.role !== '1') {
                return false;
            }
            if (!Array.isArray(this.reviewStepsData) || this.reviewStepsData.length === 0) {
                return false;
            }
            return this.reviewStepsData.some(step => step.stepTypeCode === '0601' || step.stepTypeCode === '0602');
        },
        showSecondButtonsCheck() {
            if (!Array.isArray(this.reviewStepsData) || this.reviewStepsData.length === 0) {
                return false;
            }
            return this.reviewStepsData.some(step => step.stepTypeCode === '0601' || step.stepTypeCode === '0602');

        },

        // 根据 completed 控制可见的最大步骤索引
        // 规则：
        // 1) 如果全部 completed 都是 0，则 activeVisibleIndex = 0（只显示第 1 行按钮）
        // 2) 从头往后找到最后一个 completed == 1 的索引 lastDone，activeVisibleIndex = lastDone + 1
        //    例如 [1,1,0,0] -> 最后一个 1 在索引 1，则索引 0,1,2 共三行可见
        activeVisibleIndex() {
            if (!Array.isArray(this.reviewStepsData) || this.reviewStepsData.length === 0) {
                return 0;
            }
            let lastDoneIndex = -1;
            for (let i = 0; i < this.reviewStepsData.length; i++) {
                if (this.reviewStepsData[i].completed == 1) {
                    lastDoneIndex = i;
                } else {
                    break;
                }
            }
            return lastDoneIndex + 1;
        }
    },
    watch: {
        // 监听投标单位选择变化，根据当前打开的弹窗和文档类型重新加载对应PDF和目录
        userId(newVal) {
            if (!newVal) return
            // 投标文件弹窗：更新主PDF和目录
            if (this.drawer) {
                this.getBidderFile()
                this.getBidCatalogue()
            }
            // 文件对比弹窗左侧为投标文件时，更新左侧PDF
            if (this.drawer2 && this.leftDocType === '投标文件') {
                this.getBidderFile(newVal, 'left')
                this.getBidCatalogue(newVal)
            }
            // 文件对比弹窗右侧为投标文件时，更新右侧PDF
            if (this.drawer2 && this.rightDocType === '投标文件') {
                this.getBidderFile(newVal, 'right')
                this.getBidCatalogue(newVal)
            }
        }
    },
    mounted() {
        this.initData()
        this.evaluationEndQuery()
        this.subscribeExpertScore()

        this.projectInfo()
     
    },
    methods: {
        //获取项目信息
        projectInfo() {
            getProjectInfo(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.projectType = res.data.projectType
                    if (this.projectType != '01') {
                          this.getExpertGroupList()
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        //客观打分topic监听
        subscribeExpertScore() {

            subscribeExpertScore(this.sectionCode).then(res => {
                if (res.code === 200) {
                    MQTT.disconnect()
                    this.initMqtt(res.data)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 初始mqtt 
        initMqtt(topic) {
            // 随机数
            var num = Math.floor(Math.random() * 1000000000000000000)
            MQTT.connect(mqttUrl, {
                username: '',
                password: '',
                clientId: num,
                keepalive: 60,
                clean: true
            })
            // // 监听连接成功
            MQTT.on('connect', (e) => {
            })
            MQTT.subscribe(topic, (message) => {
                console.log(message);
                this.$notify({
                    title: '客观打分',
                    message: h('i', { style: 'color: teal' }, message)
                });
            }, { qos: 2 })
            // // 监听错误
            MQTT.on('error', (err) => {
                console.error('链接失败', err)
            })

        },
        //查询评标是否结束
        evaluationEndQuery() {
            evaluationEndQuery(this.sectionCode).then(res => {
                if (res.code === 200) {
                    console.log('查询评标是否结束:', res)

                    if (res.data) {
                        this.evaluationStatus = res.data.evaluationStatus

                        // 如果是组长且评标未结束，展示评标结束按钮
                        if (this.role == 1 && res.data.evaluationStatus != 2) {
                            this.showEvaluationEndButton = true
                        }
                    } else {
                        console.warn('评标结束查询返回数据为空')
                    }
                } else {
                    this.$message.error(res.msg || '查询评标状态失败')
                }
            }).catch(error => {
                console.error('查询评标是否结束失败:', error)
                this.$message.error('查询评标状态失败')
            })
        },
        // 操作评标结束 
        handleEvaluationEndUpdate() {
            this.$confirm('是否要结束当前项目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                evaluationEndUpdate(this.sectionCode).then(res => {
                    if (res.code === 200) {
                        this.evaluationEndQuery()
                        window.location.reload()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => { })
        },
        // 切换投标文件单位
        handleBidderChange(vl) {
            console.log(vl);
            this.getBidderFile(vl)
        },
        //  初始化页面数据
        initData() {
            this.getBidderList()
            this.getStepList()
        },
        // 获取步骤
        getStepList() {
            getStepList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.reviewStepsData = res.data
                    // 判断有没有小微企业审核stepTypeCode（0602）
                    if (this.reviewStepsData.some(step => step.stepTypeCode === '0602') && role == 1) {
                        this.showMicroEnterpriseReview = true
                    }
                    if (this.reviewStepsData.some(step => step.stepTypeCode === '0601')) {

                        this.invalidOfferid = this.reviewStepsData.find(step => step.stepTypeCode === '0601').stepId

                    }

                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 判断当前步骤的按钮区是否可见
        isStepVisible(index) {
            if (!Array.isArray(this.reviewStepsData) || this.reviewStepsData.length === 0) {
                return false;
            }
            // 忽略0601 / 0602
            const steps = this.reviewStepsData.filter(step => step.stepTypeCode !== '0601' && step.stepTypeCode !== '0602')
            if (steps.length === 0) {
                return false;
            }
            let lastDoneIndex = -1
            for (let i = 0; i < steps.length; i++) {
                // 如果 skip == 1，跳过这个步骤并标记为已完成
                if (steps[i].skip == 1) {
                    steps[i].completed = 1
                    steps[i].skipped = true // 标记为跳过状态，用于显示
                    lastDoneIndex = i
                    continue
                }
                if (steps[i].completed == 1) {
                    lastDoneIndex = i
                } else {
                    break
                }
            }
            const activeVisibleIndex = lastDoneIndex + 1
            // 如果是组员（role != 1），对于 stepTypeCode 为 03、04、05 的步骤
            // 需要检查 stepTypeCode 01 和 02 是否都已完成或跳过
            if (this.role != '1') {
                const currentStep = steps[index]
                if (currentStep && ['03', '04', '05'].includes(currentStep.stepTypeCode)) {
                    // 检查 stepTypeCode 01 和 02 是否都已完成或跳过
                    // 注意：可能有多个 02 类型的步骤，需要检查所有的 01 和 02 是否都完成
                    const step01List = steps.filter(s => s.stepTypeCode === '01')
                    const step02List = steps.filter(s => s.stepTypeCode === '02')

                    // 所有 01 类型的步骤都已完成或跳过
                    const allStep01Completed = step01List.length > 0 && step01List.every(s => s.completed == 1 || s.skip == 1)
                    // 所有 02 类型的步骤都已完成或跳过
                    const allStep02Completed = step02List.length > 0 && step02List.every(s => s.completed == 1 || s.skip == 1)

                    // 如果 01 和 02 都已完成或跳过，则可以查看（返回 true）
                    // 如果当前步骤（03/04/05）已完成或跳过，也可以查看
                    // 否则不可见（返回 false）
                    if (allStep01Completed && allStep02Completed) {
                        // 01 和 02 都完成了，可以查看
                        return true
                    } else if (currentStep.completed == 1 || currentStep.skip == 1) {
                        // 当前步骤已完成或跳过，也可以查看
                        return true
                    } else {
                        return false
                    }
                }
            }

            return index <= activeVisibleIndex
        },
        // 获取投标单位列表
        getBidderList(side) {
            getBidderList().then(res => {
                if (res.code === 200) {
                    this.bidderList = res.data

                    if (res.data.length > 0) {
                        const firstUserId = res.data[0].userId

                        // 根据 side 参数设置对应的 userId
                        if (side === 'left') {
                            this.leftUserId = firstUserId
                        } else if (side === 'right') {
                            this.rightUserId = firstUserId
                        } else {
                            this.userId = firstUserId
                        }

                        this.getBidderFile(firstUserId, side)
                        this.getBidCatalogue(firstUserId)
                    } else {
                        this.$message.error("投标单位列表为空")
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //根据userId和标段编码，获取投标文件
        getBidderFile(userIdParam, side) {
            const uid = userIdParam || this.userId
            getBidderFile({
                userId: uid, sectionCode: this.sectionCode
            }).then(res => {
                if (res.code === 200) {
                    // 默认更新主PDF
                    if (!side) {
                        this.basePdfUrl = res.data
                    }
                    // 文件对比：按侧更新左右PDF
                    if (side === 'left') {
                        this.leftPdfUrl = res.data
                    } else if (side === 'right') {
                        this.rightPdfUrl = res.data
                    }
                    this.pdfUrl = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        ////根据项目编号和用户ID获取标段下投标文件目录
        getBidCatalogue(userIdParam) {
            const uid = userIdParam || this.userId
            getBidCatalogue({
                userId: uid, sectionCode: this.sectionCode
            }).then(res => {
                if (res.code === 200) {
                    this.catalogueList = res.data || []
                    // 默认展开第一层
                    this.defaultExpandedKeys = this.catalogueList.map(item => item.strId)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 点击章节目录跳转到对应PDF页码
        handleCatalogueClick(data) {
            if (data.pageNum && this.$refs.pdfViewer) {
                this.$refs.pdfViewer.goToPage(data.pageNum)
            }
        },
        // 文件对比左侧：点击章节跳转到左侧PDF对应页码
        handleLeftCatalogueClick(data) {
            if (data.pageNum && this.$refs.leftPdfViewer) {
                this.$refs.leftPdfViewer.goToPage(data.pageNum)
            }
        },
        // 文件对比右侧：点击章节跳转到右侧PDF对应页码
        handleRightCatalogueClick(data) {
            if (data.pageNum && this.$refs.rightPdfViewer) {
                this.$refs.rightPdfViewer.goToPage(data.pageNum)
            }
        },
        // 获取招标文件
        getInvitationMain(side) {
            getInvitationMain(this.sectionCode).then(res => {
                if (res.code === 200) {
                    // 默认更新主PDF及左右对比PDF
                    if (!side) {
                        this.basePdfUrl = res.data
                        this.leftPdfUrl = res.data
                        this.rightPdfUrl = res.data
                    }
                    // 文件对比：按侧更新
                    if (side === 'left') {
                        this.leftPdfUrl = res.data
                    } else if (side === 'right') {
                        this.rightPdfUrl = res.data
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取开标记录
        getOpeningRecordDetail() {
            getOpeningRecordDetail(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.openingRecordContent = (res.data && res.data.content) || ''
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //评委组长-获取改价信息
        getOfferList() {
            getOfferList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    console.log('调整投标单位报价数据:', JSON.stringify(res.data));

                    // 处理 bidders 数据，将 priceItems 转换为 priceMap 以便编辑
                    const bidders = res.data.bidders || []
                    this.bidUnitsData = bidders.map(bidder => {
                        const priceMap = {}
                        if (bidder.priceItems && Array.isArray(bidder.priceItems)) {
                            bidder.priceItems.forEach(item => {
                                priceMap[item.itemKey] = item.price
                            })
                        }
                        return {
                            userId: bidder.userId,
                            userName: bidder.userName,
                            priceItems: bidder.priceItems,
                            priceMap: priceMap // 用于 v-model 绑定
                        }
                    })

                    // 处理调整历史数据，将 priceList 转换为 priceMap 以便显示
                    const historyList = res.data.historyList || []
                    this.adjustmentHistoryData = historyList.map(record => {
                        const priceMap = {}
                        if (record.priceList && Array.isArray(record.priceList)) {
                            record.priceList.forEach(item => {
                                priceMap[item.itemKey] = item.priceInfo
                            })
                        }
                        return {
                            userId: record.userId,
                            userName: record.userName,
                            adjustTime: record.adjustTime,
                            adjustReason: record.adjustReason,
                            priceList: record.priceList,
                            priceMap: priceMap // 用于表格显示
                        }
                    })
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //组长调整
        getAdjust() {
            // 将 priceMap 转换回 priceItems 格式
            const list = this.bidUnitsData.map(bidder => {
                const priceItems = []
                if (bidder.priceMap) {
                    Object.keys(bidder.priceMap).forEach(itemKey => {
                        const originalItem = bidder.priceItems.find(item => item.itemKey === itemKey)
                        if (originalItem) {
                            priceItems.push({
                                id: originalItem.id,
                                itemKey: itemKey,
                                itemName: originalItem.itemName,
                                price: bidder.priceMap[itemKey]
                            })
                        }
                    })
                }
                return {
                    userId: bidder.userId,
                    userName: bidder.userName,
                    priceItems: priceItems
                }
            })

            const params = {
                adjustReason: this.adjustmentReason,
                list: list,
                sectionCode: this.sectionCode
            }

            getAdjust(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('调整成功');
                    this.handlePriceAdjustmentDialogClose();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //  组长二次报价废除
        invalidOffer() {
            invalidOffer(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.$message.success('废除成功');
                    this.handlePriceAdjustmentDialogClose();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },




        // 打开二次报价废除弹窗
        openInvalidOfferDialog() {
            getBidderList().then(res => {
                if (res.code === 200) {
                    this.bidderList = res.data
                    if (res.data.length > 0) {
                        this.invalidOfferList = res.data
                        this.invalidOfferDialogVisible = true
                    } else {
                        this.$message.error("投标单位列表为空")
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 处理查看报价弹窗中的废除按钮
        handleAbolishOffer(row) {
            // 保存当前要废除的报价信息
            this.abolishOfferInfo = {
                itemName: row.itemName,
                userName: row.userName,
                userId: row.userId
            }
            // 重置表单
            this.abolishForm.reason = ''
            if (this.$refs.abolishForm) {
                this.$refs.abolishForm.clearValidate()
            }
            // 打开废除理由弹窗
            this.abolishReasonDialogVisible = true
        },

        // 确认废除
        handleConfirmAbolish() {
            this.$refs.abolishForm.validate((valid) => {
                if (valid) {
                    this.invalidOffersGet(this.abolishOfferInfo)
                } else {
                    this.$message.warning('请填写完整的废除理由')
                    return false
                }
            })
        },
        invalidOffersGet(row) {
            this.abolishSubmitting = true
            invalidOffersGet({
                reason: this.abolishForm.reason,
                sectionCode: this.sectionCode,
                stepId: this.invalidOfferid,
                userId: row.userId
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('废除成功')
                    // 关闭废除理由弹窗
                    this.abolishReasonDialogVisible = false
                    // 关闭查看报价弹窗
                    this.viewOfferDialogVisible = false
                    // 刷新列表
                    // this.openInvalidOfferDialog()
                } else {
                    this.$message.error(res.msg || '废除失败')
                }
            }).catch(error => {
                console.error('废除失败:', error)
                this.$message.error('废除失败，请重试')
            }).finally(() => {
                this.abolishSubmitting = false
            })
        },

        // 处理单个投标人的废除操作
        handleInvalidOffer(row) {
            this.$prompt(`请输入废除投标单位"${row.userName}"的理由`, '废除理由', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputPlaceholder: '请输入废除理由',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                        return '废除理由不能为空'
                    }
                    return true
                }
            }).then(({ value }) => {
                // 调用废除接口
                this.callInvalidOfferApi(row, value.trim())
            }).catch(() => {
            })
        },

        // 调用废除接口
        callInvalidOfferApi(row, reason) {
            invalidOffer({
                sectionCode: this.sectionCode,
                userId: row.userId,
                invalidOffer: reason
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('废除成功')
                    // 刷新列表
                    this.openInvalidOfferDialog()
                } else {
                    this.$message.error(res.msg || '废除失败')
                }
            }).catch(error => {
                console.error('废除失败:', error)
                this.$message.error('废除失败，请重试')
            })
        },

        // 澄清-补遗文件列表
        getEvaluationAgentFile(vl) {
            getEvaluationAgentFile(vl).then(res => {
                if (res.code === 200) {
                    this.clarificationData.attachments = res.data || [];
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 澄清-补遗列表  （1：文件，2：补遗书，3：澄清文件）
        getClarificationList(vl) {
            getClarificationList({
                documentType: vl,
                sectionCode: this.sectionCode
            }).then(res => {
                if (res.code === 200) {
                    this.documentListData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 打开招标文件列表弹窗（澄清/补遗共用）
        openDocumentList(type) {
            this.documentListType = type;
            this.documentListDialogVisible = true;
            switch (type) {
                case 'clarification':
                    this.getClarificationList(3);
                    break;
                case 'supplement':
                    this.getClarificationList(2);
                    break;
            }
        },
        //  获取补遗内容
        getEvaluationAgentContent(id) {
            getEvaluationAgentContent(id).then(res => {
                if (res.code === 200) {
                    this.clarificationData.content = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 列表中“详情”点击：根据类型再打开原有澄清/补遗弹窗
        handleDocumentDetail(row) {
            this.getEvaluationAgentFile(row.id);
            this.getEvaluationAgentContent(row.id)
            this.documentListDialogVisible = false;
            if (this.documentListType === 'clarification') {
                this.openDialog('clarificationDialogVisible');
                this.activeClarificationTab = 'clarificationContent';

            } else if (this.documentListType === 'supplement') {
                this.openDialog('supplementDialogVisible');
                this.activeSupplementTab = 'supplementContent';
            }
        },

        //获取招标文件附件列表（并按 fileExtension 分组）
        getInvitationAttList() {
            // 重置附件数据
            this.attachmentData = {};
            this.attachmentTypes = [];
            getInvitationAttList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    const list = Array.isArray(res.data) ? res.data : [];
                    const grouped = {};
                    list.forEach((item) => {
                        const type = item.fileExtension || '其他';
                        if (!grouped[type]) {
                            grouped[type] = [];
                        }
                        grouped[type].push(item);
                    });
                    // 按照no排序
                    Object.keys(grouped).forEach((type) => {
                        grouped[type] = grouped[type].map((item, index) => ({
                            ...item,
                            no: index + 1,
                        }));
                    });
                    this.attachmentData = grouped;
                    this.attachmentTypes = Object.keys(grouped);

                    // 默认选中第一个类型
                    this.activeAttachmentTab = this.attachmentTypes.length ? this.attachmentTypes[0] : '';
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取异常文件
        getAnomalousList() {
            getAnomalousList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.abnormalBehaviorData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 流程终止接口
        terminate() {
            terminate({
                sectionCode: this.sectionCode,
                reason: this.terminationReason,
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('终止成功');
                    this.handlePriceAdjustmentDialogClose();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 打开附件查看弹窗
        openAttachmentView() {
            this.attachmentViewList = []
            this.attachmentViewDialogVisible = true
        },

        // 底部操作按钮
        handlebottomAction(type) {
            switch (type) {
                case '二次报价':
                    this.getOfferConfigList()
                    break;
                case '小微企业审核':
                    this.microAuditDrawerVisible = true
                    this.getStepMesList()
                    break;
                case '查看报价':
                    this.getOfferListForEvaluation()
                    break;
            }
        },
        // 小微企业列表
        getStepMesList() {
            getStepMesList({ sectionCode: this.sectionCode }).then(res => {
                if (res.code === 200) {
                    this.microAuditList = res.data
                    this.microAuditCompanyOptions = res.data
                    if (this.microAuditCompanyOptions.length > 0) {
                        this.selectedMicroCompany = this.microAuditCompanyOptions[0].userId
                        this.getBidderFile(this.microAuditCompanyOptions[0].userId)
                    } else {
                        this.$message.error("暂无企业")
                        setTimeout(() => {
                            this.microAuditDrawerVisible = false
                        }, 500);
                    }
                } else {
                    this.microAuditList = []
                    this.$message.error(res.msg)
                }
            })
        },
        // 小微企业优惠保存
        handleSaveMicroAudit() {
            const list = (this.microAuditList || []).map(item => ({
                userId: item.userId,
                isDiscount: item.isDiscount,
                discount: item.isDiscount ? item.discount : null
            }))
            const params = {
                sectionCode: this.sectionCode,
                list
            }
            saveStepMse(params).then(res => {
                if (res.code === 200) {
                    this.$message.success('小微企业优惠已保存')
                    this.getStepMesList()
                    this.microAuditDrawerVisible = false
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 小微企业切换
        handleChange(vl) {
            this.getBidderFile(vl)
        },
        // 查看报价 
        getOfferListForEvaluation() {
            getOfferListForEvaluation(this.sectionCode).then(res => {
                if (res.code === 200) {
                    console.log('查看报价数据:', JSON.stringify(res.data));
                    this.viewOfferList = Array.isArray(res.data) ? res.data : []
                    this.viewOfferDialogVisible = true
                } else {
                    this.viewOfferList = []
                    this.$message.error(res.msg)
                }
            })
        },
        // 评委组长-二次报价配置列表
        getOfferConfigList() {
            getOfferConfigList(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.secondQuoteDialogVisible = true
                    this.secondQuoteList = res.data.tbidPriceAdjustConfigItems || []
                    this.timeInterval = Number(res.data.timeInterval) || 0
                    this.countdown = this.parseTimeStringToSeconds(res.data.countdown)
                    this.isEnable = res.data.isEnable
                    // 处理投标单位列表
                    this.bidderUserList = res.data.userList || []
                    // 如果有已选中的投标单位，初始化 selectedBidders
                    if (res.data.selectedUserIds && Array.isArray(res.data.selectedUserIds)) {
                        this.selectedBidders = res.data.selectedUserIds
                    } else {
                        // 默认全选
                        this.selectedBidders = this.bidderUserList.map(user => user.userId)
                    }
                    // 如果有倒计时时间且大于0，启动倒计时
                    if (this.countdown > 0) {
                        console.log('准备启动倒计时，倒计时值:', this.countdown)
                        this.startCountdown()
                    } else {
                        console.log('倒计时值为0或无效，不启动倒计时:', this.countdown)
                    }
                } else {
                    this.$message.error(res.msg || '获取二次报价配置失败')
                }
            }).catch(error => {
                console.error('获取二次报价配置失败:', error)
                this.$message.error('获取二次报价配置失败')
            })
        },


        // 文件对比：切换文档类型（招标文件/投标文件），按面板侧控制
        setActiveDocType(type, side = 'left') {
            console.log('setActiveDocType ->', side, type)
            switch (side) {
                case 'left':
                    this.leftDocType = type
                    break;
                case 'right':
                    this.rightDocType = type
                    break;
                default:
                    this.activeDocType = type
                    break;
            }
            // 根据选择的文档类型和侧边，调用对应接口
            if (type === '招标文件') {
                this.getInvitationMain(side)
            } else if (type === '投标文件') {
                this.getBidderList(side)
            }
        },

        // 二次报价清单：新增条目
        addSecondQuoteItem() {
            this.secondQuoteList.push({ itemName: '', itemKey: '', itemType: '0', editing: true })
        },
        // 二次报价清单：删除条目（itemType 为 1/2/3 的不允许删除）
        removeSecondQuoteItem(index, row) {
            if (!row) {
                return
            }
            const type = Number(row.itemType)
            if ([1, 2, 3].includes(type)) {
                this.$message.warning('该条目为必填项，不允许删除')
                return
            }
            if (index > -1 && index < this.secondQuoteList.length) {
                this.secondQuoteList.splice(index, 1)
            }
        },
        // 二次报价清单：确认
        confirmSecondQuote() {
            // 验证是否选择了投标单位
            if (this.selectedBidders.length === 0) {
                this.$message.warning('请至少选择一个投标单位')
                return
            }

            this.secondQuoteList = this.secondQuoteList.map(item => ({ ...item, editing: false }))
            this.saveOfferConfig()
        },
        //评委组长-二次报价
        saveOfferConfig() {
            saveOfferConfig({
                sectionCode: this.sectionCode,
                timeInterval: this.timeInterval,
                list: this.secondQuoteList,
                userIds: this.selectedBidders, // 提交选中的投标单位
                isUpload: this.isUpload ? 1 : 0 // 是否必须上传附件
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('已保存二次报价清单')
                    this.secondQuoteDialogVisible = false
                } else {
                    this.$message.error(res.msg || '保存失败')
                }
            }).catch(error => {
                console.error('保存二次报价配置失败:', error)
                this.$message.error('保存失败，请重试')
            })
        },


        // 通用弹窗打开方法
        openDialog(dialogName) {
            this[dialogName] = true;
        },
        // 通用弹窗关闭方法
        closeDialog(dialogName) {
            this[dialogName] = false;
        },
        // 开始评审
        handleStartReview(vl) {
            if (vl.skip == 1) {
                this.$message.warning('该步骤已跳过，无法进行操作')
                return;
            }
            this.createStepRecord(vl)
        },
        //创建评审记录
        createStepRecord(vl) {
            if (vl.completed == 1) {
                if (vl.stepTypeCode == '01' || vl.stepTypeCode == '02') {
                    this.$router.push({ path: '/qualificateStep', query: { stepId: vl.stepId, stepTypeCode: vl.stepTypeCode, evaluationStatus: this.evaluationStatus } });
                } else if (vl.stepTypeCode == '03') {
                    this.getBasePriceDes()
                } else if (vl.stepTypeCode == '04') {
                    this.getStepQuotationList()
                } else if (vl.stepTypeCode == '05') {
                    this.viewCandidateDialogVisible = false;
                    this.getRecommendList(vl.completed)
                }
                return;
            }
            createStepRecord({
                sectionCode: vl.sectionCode,
                stepId: vl.stepId
            }).then(res => {
                if (res.code === 200) {
                    if (vl.stepTypeCode == '01' || vl.stepTypeCode == '02') {
                        this.$router.push({ path: '/qualificateStep', query: { stepId: vl.stepId, stepTypeCode: vl.stepTypeCode, evaluationStatus: this.evaluationStatus } });
                    } else if (vl.stepTypeCode == '03') {
                        this.getBasePriceDes()
                    } else if (vl.stepTypeCode == '04') {
                        this.getStepQuotationList()
                    } else if (vl.stepTypeCode == '05') {
                        this.getRecommendList(vl.completed)
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 开始计算
        handleStartCalculate(vl) {
            if (vl.skip == 1) {
                this.$message.warning('该步骤已跳过，无法进行操作')
                return;
            }
            this.stepId = vl.stepId
            if (vl.stepTypeCode == "03") {
                this.openDialog('benchmarkPriceDialogVisible');
                this.createStepRecord(vl)
            } else if (vl.stepTypeCode == "04") {
                this.openDialog('bidScoreDialogVisible');
                this.createStepRecord(vl)
            }
        },
        // 组员查看计算结果（只读模式）
        handleViewCalculate(vl) {
            if (vl.skip == 1) {
                this.$message.warning('该步骤已跳过')
                return;
            }
            this.stepId = vl.stepId
            if (vl.stepTypeCode == "03") {
                // 查看基准价
                this.getBasePriceDes()
                this.openDialog('benchmarkPriceDialogVisible');
            } else if (vl.stepTypeCode == "04") {
                // 查看报价得分
                this.getStepQuotationList()
                this.openDialog('bidScoreDialogVisible');
            }
        },
        //获取基准价描述接口
        getBasePriceDes() {
            getBasePriceDes({
                stepId: this.stepId
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.message != '' && res.data.message != null) {
                        this.basePriceDesLines = res.data.message.split(';')
                    }
                    console.log('getBasePriceDes ->', res.data)
                    this.benchmarkPriceData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        //获取报价得分列表
        getStepQuotationList() {
            getStepQuotationList({
                sectionCode: this.sectionCode,
                stepId: this.stepId
            }).then(res => {
                if (res.code === 200) {
                    this.bidScoreData = res.data.item
                    this.quotationData = {
                        description: res.data.description,
                        manCalculate: res.data.manCalculate,
                    }

                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 专家获取证书列表接口
        getExpertCertList() {
            this.certList =[];
            getExpertCertList().then(res => {
                if (res.code === 200) {
                     console.log("-------专家获取证书列表接口11");
                       console.log( this.certList);
                          console.log("-------专家获取证书列表接口22");
                    
                    this.certList = res.data

                        console.log("-------专家获取证书列表接口11");
                       console.log( this.certList);
                          console.log("-------专家获取证书列表接口22");
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 关闭计算基准价弹窗
        handleBenchmarkPriceDialogClose() {
            this.closeDialog('benchmarkPriceDialogVisible');
            this.getStepList()
        },
        // 推荐中标候选人
        handleStartRecommendWinnerCandidate(vl) {
            this.stepId = vl.stepId
            switch (vl.stepTypeCode) {
                case '05':
                    this.openDialog('winnerCandidateDialogVisible');
                    this.createStepRecord(vl)
                    break;
                case '0601':
                    if (this.countdown == 0) {
                        this.$confirm('是否要开启二次报价环节', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.getOfferConfigList();
                        }).catch(() => { })

                    } else {
                        this.getOfferConfigList();
                    }


                    break;
                case '0602':
                    this.microAuditDrawerVisible = true
                    this.getStepMesList()
                    break;
                default:
                    break;
            }
        },
        // 推荐候选人查看
        handleStartRecommendWinner(vl) {
            this.stepId = vl.stepId
            this.winnerCandidateDialogVisible = true;
            this.viewCandidateDialogVisible = true;
            this.getRecommendList(vl.completed)

        },
        // 推荐中标候选人
        getRecommendList(completed) {
            getRecommendList({
                sectionCode: this.sectionCode,
                stepId: this.stepId,
                completed: completed
            }).then(res => {
                if (res.code === 200) {
                    console.log(JSON.stringify(res.data));

                    const data = res.data || {}
                    const items = Array.isArray(data.items) ? data.items : []
                    const prices = Array.isArray(data.prices) ? data.prices : []
                    const quotes = Array.isArray(data.quotes) ? data.quotes : []
                    const scores = Array.isArray(data.scores) ? data.scores : []
                    const basePrices = Array.isArray(data.basePrice) ? data.basePrice : []

                    // 1. 按 userId 分组 prices，得到每个投标人的报价数组
                    const pricesByUser = {}
                    prices.forEach(p => {
                        if (!p || !p.userId) return
                        if (!pricesByUser[p.userId]) {
                            pricesByUser[p.userId] = []
                        }
                        pricesByUser[p.userId].push(p)
                    })

                    let maxPriceCount = 0
                    Object.keys(pricesByUser).forEach(userId => {
                        const len = pricesByUser[userId].length
                        if (len > maxPriceCount) {
                            maxPriceCount = len
                        }
                    })

                    let titlePrefix = '报价'
                    if (prices.length && prices[0].title) {
                        titlePrefix = prices[0].title
                    }
                    const winnerPriceColumns = []
                    for (let i = 0; i < maxPriceCount; i++) {
                        winnerPriceColumns.push({
                            prop: `col_${i}`,
                            label: `${titlePrefix}`
                        })
                    }

                    // 2. 处理报价得分（quotes）- 固定表头"报价得分"
                    const quotesByUser = {}
                    quotes.forEach(q => {
                        if (!q || !q.userId) return
                        if (!quotesByUser[q.userId]) {
                            quotesByUser[q.userId] = []
                        }
                        quotesByUser[q.userId].push(q)
                    })

                    const winnerQuoteColumns = []
                    let maxQuoteCount = 0
                    Object.keys(quotesByUser).forEach(userId => {
                        const len = quotesByUser[userId].length
                        if (len > maxQuoteCount) {
                            maxQuoteCount = len
                        }
                    })
                    for (let i = 0; i < maxQuoteCount; i++) {
                        winnerQuoteColumns.push({
                            prop: `quote_${i}`,
                            label: '报价得分'
                        })
                    }

                    // 3. 处理评分项得分（scores）- 动态表头，根据 title 生成
                    const scoresByUser = {}
                    const scoreTitles = new Set()
                    scores.forEach(s => {
                        if (!s || !s.userId) return
                        if (!scoresByUser[s.userId]) {
                            scoresByUser[s.userId] = []
                        }
                        scoresByUser[s.userId].push(s)
                        if (s.title) {
                            scoreTitles.add(s.title)
                        }
                    })

                    const winnerScoreColumns = Array.from(scoreTitles).map((title, index) => ({
                        prop: `score_${index}`,
                        label: title,
                        title: title // 保存原始 title 用于匹配
                    }))

                    const winnerCandidateData = items.map(item => {
                        const row = {
                            id: item.id,
                            rank: item.rank,
                            userName: item.userName,
                            userId: item.userId,
                            isRecommended: true,
                            totalScore: item.score || '',  // 总分
                            basePrice: ''  // 计算基准价
                        }

                        // 填充计算基准价
                        const userBasePrice = basePrices.find(bp => bp.userId === item.userId)
                        if (userBasePrice) {
                            row.basePrice = userBasePrice.price
                        }

                        // 填充报价列
                        const userPrices = pricesByUser[item.userId] || []
                        winnerPriceColumns.forEach((col, index) => {
                            const priceItem = userPrices[index]
                            if (priceItem) {
                                const val = Number(priceItem.price)
                                row[col.prop] = isNaN(val) ? priceItem.price : val
                            } else {
                                row[col.prop] = ''
                            }
                        })

                        // 填充报价得分列
                        const userQuotes = quotesByUser[item.userId] || []
                        winnerQuoteColumns.forEach((col, index) => {
                            const quoteItem = userQuotes[index]
                            if (quoteItem) {
                                row[col.prop] = quoteItem.score
                            } else {
                                row[col.prop] = ''
                            }
                        })

                        // 填充评分项得分列
                        const userScores = scoresByUser[item.userId] || []
                        winnerScoreColumns.forEach(col => {
                            const scoreItem = userScores.find(s => s.title === col.title)
                            if (scoreItem) {
                                row[col.prop] = scoreItem.markingScore
                            } else {
                                row[col.prop] = ''
                            }
                        })

                        return row
                    })

                    this.winnerPriceColumns = winnerPriceColumns
                    this.winnerQuoteColumns = winnerQuoteColumns
                    this.winnerScoreColumns = winnerScoreColumns
                    this.winnerCandidateData = winnerCandidateData
                    this.adjustmentReason = data.adjustReason || ''
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 计算基准价
        handleCalculateBenchmarkPrice() {
            if (this.benchmarkPriceData.status != 1) {
                this.calculateBasePrice()
            } else {
                this.saveBasePrice()
            }
        },
        //计算基准价
        calculateBasePrice() {
            let data = {
                price: this.price,
                rate: this.rate,
                sectionCode: this.sectionCode,
                stepId: this.stepId,
            }
            calculateBasePrice(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('已计算基准价')
                    this.price = res.data;
                    this.benchmarkPriceData.price = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 保存基准价
        saveBasePrice() {
            let data = {
                price: this.price,
                rate: this.rate,
                sectionCode: this.sectionCode,
                stepId: this.stepId,
            }
            saveBasePrice(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('已保存基准价')
                    this.handleBenchmarkPriceDialogClose()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        // 关闭计算报价得分弹窗
        handleBidScoreDialogClose() {
            this.closeDialog('bidScoreDialogVisible');
            this.getStepQuotationList()
        },
        // 计算报价得分
        handleCalculateBidScore() {
            //  如果是手工的话 调用 手动输入报价得分
            if (this.quotationData.manCalculate == 1) {
                this.inputStepQuotation()
            } else {
                this.calculateBidScoreList()
            }
        },
        //计算报价得分列表
        calculateBidScoreList() {
            let data = {
                items: this.bidScoreData,
                stepId: this.stepId
            }
            calculateStepQuotation(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('已保存报价得分')
                    this.getStepQuotationList()
                    this.initData()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 输入报价得分
        inputStepQuotation() {
            let data = {
                item: this.bidScoreData,
                stepId: this.stepId
            }
            inputStepQuotation(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('已保存报价得分')
                    this.initData()
                    this.closeDialog('bidScoreDialogVisible');
                }
            })
        },
        // 关闭推荐中标候选人弹窗
        handleWinnerCandidateDialogClose() {
            this.viewCandidateDialogVisible = false;
            this.closeDialog('winnerCandidateDialogVisible');
        },
        // 保存推荐中标候选人
        handleSaveWinnerCandidate() {
            // 从弹窗表格数据中提取排名信息
            const items = (this.winnerCandidateData || []).map(row => ({
                id: row.id,
                ranking: row.rank
            }))

            // 过滤掉无效的排名（为空或非数字）
            const validItems = items.filter(it => it.id !== undefined && it.id !== null && it.ranking !== undefined && it.ranking !== null && it.ranking !== '')

            if (!validItems.length) {
                this.$message.warning('暂无需要保存的排名数据');
                return;
            }

            // 校验是否存在重复的排名
            const rankings = validItems.map(it => it.ranking)
            const uniqueRankings = [...new Set(rankings)]
            if (rankings.length !== uniqueRankings.length) {
                this.$message.warning('存在重复的排名，请检查后再保存');
                return;
            }

            const data = {
                adjustReason: this.adjustmentReason || '',
                items: validItems,
                stepId: this.stepId
            }

            rankUpdate(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('保存成功');
                    this.handleWinnerCandidateDialogClose();
                } else {
                    this.$message.error(res.msg || '保存失败');
                }
            })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1);
        },
        // 打开弹窗
        handleOpenDrawer(title) {
            this.drawerTitle = title;
            this.basePdfUrl = ""
            this.reportPdfUrl = ""
            this.pdfUrl = ""
            this.leftPdfUrl = ""
            this.rightPdfUrl = ""
            const actionMap = {
                '投标文件': () => {
                    this.getBidderList()
                    this.$nextTick()
                    this.drawer = true;
                },
                '招标文件': () => {

                    this.getInvitationMain()
                    this.$nextTick()
                    this.drawer1 = true;
                },
                '招标文件附件': () => {
                    this.getInvitationAttList()
                    this.$nextTick()
                    this.openDialog('attachmentDialogVisible');

                },
                '招标文件澄清及附件': () => {
                    this.openDocumentList('clarification');
                },
                '招标文件补遗及附件': () => {
                    this.openDocumentList('supplement');
                },
                '文件对比': () => {
                    this.drawer2 = true;
                    // 左侧默认招标文件，右侧默认投标文件
                    this.leftDocType = '招标文件'
                    this.rightDocType = '投标文件'
                    // 左侧加载招标文件
                    this.getInvitationMain('left')
                    // 右侧加载投标文件（获取列表并选中第一个单位）
                    this.getBidderList('right')
                },
                '开标记录': () => {
                    this.getOpeningRecordDetail()
                    this.$nextTick()
                    this.openDialog('bidOpeningDialogVisible');

                },
                '调整投标单位报价': () => {
                    if (this.role !== '1') {
                        this.$message.warning('您没有权限进行此操作');
                        return;
                    }
                    this.getOfferList()
                    this.$nextTick()
                    this.openDialog('priceAdjustmentDialogVisible');

                },
                '二次报价废除': () => {
                    if (this.role !== '1') {
                        this.$message.warning('您没有权限进行此操作');
                        return;
                    }
                    if (this.evaluationStatus == 2) {
                        this.$message.warning('当前项目已结束');
                        return;
                    }
                    this.$confirm('确定要废除此轮报价？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.invalidOffer()

                    }).catch(() => {
                    })




                    // // 打开废除弹窗
                    // this.openInvalidOfferDialog();
                },
                '评标流程终止': () => {
                    this.openDialog('processTerminationDialogVisible');
                },
                '异常行为识别': () => {
                    this.getAnomalousList()
                    this.openDialog('abnormalBehaviorDialogVisible');
                }
            };

            const action = actionMap[title];
            if (action) {
                action();
            }
        },
        // 关闭弹窗
        handleClose() {
            this.drawer = false;
            this.drawer1 = false;
            this.drawerTitle = '';
        },

        // 关闭附件弹窗
        handleAttachmentDialogClose() {
            this.attachmentDialogVisible = false;
        },

        // 关闭澄清弹窗
        handleClarificationDialogClose() {
            this.clarificationDialogVisible = false;
        },

        // 关闭补遗弹窗
        handleSupplementDialogClose() {
            this.supplementDialogVisible = false;
        },

        // 关闭开标记录弹窗
        handleBidOpeningDialogClose() {
            this.bidOpeningDialogVisible = false;
        },

        // 关闭调整投标单位报价弹窗
        handlePriceAdjustmentDialogClose() {
            this.priceAdjustmentDialogVisible = false;
            this.adjustmentReason = '';
        },

        // 确认调整
        handleConfirmAdjustment() {
            if (!this.adjustmentReason.trim()) {
                this.$message.warning('请输入调整原因');
                return;
            }
            this.getAdjust()
        },
        // 关闭评标流程终止弹窗
        handleProcessTerminationDialogClose() {
            this.processTerminationDialogVisible = false;
            this.terminationReason = '';
        },

        // 确认终止
        handleConfirmTermination() {
            if (!this.terminationReason.trim()) {
                this.$message.warning('请输入终止原因');
                return;
            }
            this.terminate()
            this.handleProcessTerminationDialogClose();
        },

        // 关闭异常行为识别弹窗
        handleAbnormalBehaviorDialogClose() {
            this.abnormalBehaviorDialogVisible = false;
        },

        // 关闭文件对比弹窗
        handleFileComparisonDialogClose() {
            this.drawer2 = false;
        },
        // 处理文件下载
        handleFileDownload(file) {
            console.log('下载文件:', file);
            if (file.fileUrl) {
                // 创建下载链接
                const link = document.createElement('a');
                link.href = file.fileUrl;
                link.download = file.fileName;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success(`开始下载: ${file.fileName}`);
            } else {
                this.$message.warning('文件链接不存在');
            }
        },
        // PDF组件事件处理方法
        onPdfLoaded(info) {
            console.log('PDF加载完成:', info);
        },

        onPdfError(error) {
            console.error('PDF加载失败:', error);
            this.$message.error('PDF文件加载失败');
        },

        onPageChanged(info) {
            console.log('页面切换:', info);
        },

        onScaleChanged(scale) {
            console.log('缩放比例变化:', scale);
        },

        // 关闭形式评审标准弹窗
        handleFormalReviewDialogClose() {
            this.formalReviewDialogVisible = false;
        },

        // 一键通过所有评审项
        handleOneClickPass() {
            this.formalReviewData.forEach(item => {
                item.bidderNameResult = true;
                item.signatureSealResult = true;
                item.documentFormatResult = true;
                item.consortiumBidderResult = true;
                item.alternativeProposalResult = true;
                item.singleQuoteResult = true;
                item.otherResult = true;
            });
            this.$message.success('已设置所有评审项为通过');
        },

        // 单个公司全通过
        handlePassAllForCompany(row) {
            row.bidderNameResult = true;
            row.signatureSealResult = true;
            row.documentFormatResult = true;
            row.consortiumBidderResult = true;
            row.alternativeProposalResult = true;
            row.singleQuoteResult = true;
            row.otherResult = true;
            this.$message.success(`${row.companyName} 已设置为全通过`);
        },

        // 评审项变化处理
        handleReviewChange(row, field) {
            console.log(`${row.companyName} 的 ${field} 评审结果:`, row[field + 'Result']);
        },

        // 提交生效
        handleSubmitEffective() {
            console.log('提交评审结果:', this.formalReviewData);
            this.$message.success('评审结果已提交生效');
            this.handleFormalReviewDialogClose();
        },

        // 打开评审报告弹窗
        openReportDialog() {
            this.getExpertCertList()
            this.getReportFile()
        },
        // 查看评审报告
        getReportFile() {
            getReportFile(this.sectionCode).then(res => {
                if (res.code === 200) {
                    console.log('------查看评审报告');
                       console.log(res);
                          console.log('------查看评审报告');
                    
                    this.signed = res.data.signed
                    const data = Array.isArray(res.data.fileList) ? res.data.fileList : (res.data.fileList ? [res.data.fileList] : [])
                    this.reportFileList = data
                    if (data.length > 0) {
                        this.currentFileIndex = 0
                        this.reportPdfUrl = data[0].fileUrl
                    } else {
                        this.currentFileIndex = -1
                        this.reportPdfUrl = ''
                    }
                    this.reportDialogVisible = true
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 选择文件
        handleFileSelect(file, index) {
            this.currentFileIndex = index
            this.reportPdfUrl = file.fileUrl
        },
        // 关闭评审报告弹窗
        closeReportDialog() {
            this.reportDialogVisible = false
            console.log('关闭评审报告弹窗')
        },
        // 提交评审报告
        submitReport() {
            // 打开密码验证弹窗
            this.passwordDialogVisible = true
            console.log('打开密码验证弹窗')
        },

        // 确认证书选择
        confirmPassword() {
            if (!this.selectedCert) {
                this.$message.warning('请选择证书')
                return
            }
            let arr = this.certList;
            const algo = arr.find(arr => arr.signCertSn === this.selectedCert);
            this.expertSign(algo)
        },
        expertSign(algo) {
            let data = {
                algo: algo.keyAlgo,
                sectionCode: this.sectionCode,
                signCertSn: this.selectedCert
            }
            expertSign(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('签字成功')
                    this.passwordDialogVisible = false
                    this.selectedCert = ''
                    // 标记报告已提交
                    this.reportSubmitted = true
                    // 关闭评审报告弹窗
                    this.closeReportDialog()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 取消证书选择
        cancelPassword() {
            this.passwordDialogVisible = false
            this.selectedCert = ''
        },
        // PDF相关事件处理方法
        onReportPdfLoaded() {
            console.log('评审报告PDF加载完成');
        },
        onReportPdfError(error) {
            console.error('评审报告PDF加载失败:', error);
            this.$message.error('PDF文件加载失败，请检查文件是否存在');
        },
        onReportPageChanged(page) {
            console.log('评审报告PDF页码变化:', page);
        },
        onReportScaleChanged(scale) {
            console.log('评审报告PDF缩放变化:', scale);
        },
        /**
         * 将时间字符串 (HH:MM:SS) 转换为秒数
         * @param {string} timeString - 时间字符串，如 '00:06:54'
         * @returns {number} 总秒数
         */
        parseTimeStringToSeconds(timeString) {
            if (!timeString || typeof timeString !== 'string') {
                return 0
            }
            const parts = timeString.split(':')
            if (parts.length !== 3) {
                return 0
            }
            const hours = parseInt(parts[0]) || 0
            const minutes = parseInt(parts[1]) || 0
            const seconds = parseInt(parts[2]) || 0

            return hours * 3600 + minutes * 60 + seconds
        },

        /**
         * 启动倒计时
         */
        startCountdown() {
            this.stopCountdown()
            this.countdown = Number(this.countdown) || 0
            this.countdownTimer = setInterval(() => {
                const currentCountdown = Number(this.countdown) || 0
                if (currentCountdown > 0) {
                    this.countdown = currentCountdown - 1
                } else {
                    this.isEnable = 0
                    // 倒计时结束
                    this.stopCountdown()
                    this.onCountdownEnd()
                }
            }, 1000)
        },

        /**
         * 停止倒计时
         */
        stopCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
        },

        /**
         * 倒计时结束处理
         */
        onCountdownEnd() {
            this.$message.warning('二次报价时间已结束')
        },

        /* ==================== 聊天功能 ==================== */
        // 打开聊天窗口
        handleOpenChat() {
            this.chatWindowVisible = true

        },

        // 关闭聊天窗口
        handleChatWindowClose() {
            this.chatWindowVisible = false
        },

        // 获取聊天群组列表
        async getExpertGroupList() {
            const res = await getExpertGroupList()
            if (res.code === 200 && res.data && res.data.length > 0) {
                this.chatGroupList = res.data.map(item => ({
                    id: item.groupId,
                    name: item.groupName,
                    memberCount: item.memberCount,
                    memberList: item.memberList,
                    headImg: 'https://img1.baidu.com/it/u=2347178170,458451905&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
                }))

                // 初始化 MQTT 连接并订阅所有群组
                try {
                    this.initAllMqttTopics()
                } catch (error) {
                    console.error('getExpertGroupList: 初始化 MQTT 失败', error)
                }

                // 默认选择第一个群组
                if (this.chatGroupList.length > 0) {
                    const firstGroup = this.chatGroupList[0]
                    this.selectedGroup = firstGroup
                    this.currentTopic = firstGroup.id

                    // 获取历史聊天记录
                    this.getChatList()
                }
            } else {
                this.chatGroupList = []
            }
        },

        // 初始化聊天 MQTT 并订阅所有群组
        initAllMqttTopics() {
            // 断开之前的连接
            MQTT.disconnect()

            const clientId = Math.floor(Math.random() * 1000000000000000000)
            MQTT.connect('ws://183.78.181.249:8083/mqtt', {
                username: '',
                password: '',
                clientId: clientId,
                keepalive: 60,
                clean: true
            })
            MQTT.on('connect', () => {
                // 连接成功后，订阅所有群组的 topic
                this.chatGroupList.forEach(group => {
                    MQTT.subscribe(group.id, (message) => {
                        const msg = JSON.parse(message)
                        // 找到消息所属的群组
                        const messageGroup = this.chatGroupList.find(g => g.id === msg.topic)
                        // 只有当消息属于当前选中的群组时，才刷新聊天记录
                        if (this.currentTopic && msg.topic === this.currentTopic) {
                            this.getChatList()
                        } 
                            const groupName = messageGroup ? messageGroup.name : '未知群组'
                            this.$notify({
                                title: `${groupName} 有新消息`,
                                message: `${msg.senderName}: ${msg.content}`,
                                duration: 2500,
                                type: 'info',
                                onClick: () => {
                                    this.chatWindowVisible = true
                                    if (messageGroup) {
                                        this.handleGroupSelected(messageGroup)
                                    }
                                }
                            })
                    }, { qos: 2 })
                    console.log('已订阅群组:', group.name, 'topic:', group.id)
                })
            })

            MQTT.on('error', (err) => {
                console.error('聊天 MQTT 连接失败:', err)
            })
        },

        // 获取历史聊天记录
        async getChatList() {
            if (!this.currentTopic) {
                console.log('getChatList: currentTopic 为空，跳过请求')
                return
            }
            try {
                const res = await getChatList(this.currentTopic)
                if (res.code === 200 && res.data) {
                    // 专家页面：senderType==0（专家自己）在右边，senderType==1（投标人）在左边
                    this.chatMessages = res.data.map(msg => ({
                        id: msg.msgId,
                        type: msg.senderType === 0 ? 'own' : 'other',
                        content: msg.content,
                        senderType: msg.senderType,
                        senderName: msg.senderName,
                        createdTime: msg.createdTime
                    }))
                    console.log('getChatList: 聊天消息已更新，消息数量:', this.chatMessages.length)
                } else {
                    console.log('getChatList: 接口返回失败或数据为空', res)
                }
            } catch (error) {
                console.error('getChatList: 请求失败', error)
            }
        },

        // 处理聊天窗口位置变化
        handleChatPositionChange(newPosition) {
            this.chatWindowPosition = newPosition
        },

        // 处理发送消息
        async handleSendMessage(newMessage) {
            if (!newMessage.content || !newMessage.content.trim()) return
            try {
                const res = await sendMessage({
                    groupId: this.currentTopic,
                    msg: newMessage.content,
                    userName: Cookies.get('userName') || this.currentUser.name,
                    msgType: 1
                })
                if (res.code === 200) {
                    this.getChatList()
                } else {
                    this.$message.error(res.msg || '发送消息失败')
                }
            } catch (error) {
                console.error('发送消息失败:', error)
                this.$message.error('发送消息失败')
            }
        },

        // 处理群组选择
        handleGroupSelected(group) {
            console.log('handleGroupSelected: 选择群组', group)
            // 允许重复选择，以便刷新消息
            this.selectedGroup = group
            this.currentTopic = group.id
            console.log('handleGroupSelected: 设置 currentTopic 为', this.currentTopic)
            this.chatMessages = []

            // 不需要重新连接 MQTT，因为已经订阅了所有群组
            // 只需要重新请求当前群组的聊天记录
            console.log('handleGroupSelected: 调用 getChatList')
            this.getChatList()
        },

    },

    /**
     * 组件销毁前清理定时器
     */
    beforeDestroy() {
        this.stopCountdown()
        // 清理聊天 MQTT 连接
        MQTT.disconnect()
    },

    /**
     * 监听数据变化
     */
    watch: {
        // 监听二次报价弹窗关闭，停止倒计时
        secondQuoteDialogVisible(newVal) {
            if (!newVal) {
                this.stopCountdown()
            }
        }
    }
}
</script>

<style lang="less" scoped>
// 公共样式变量
@primary-color: #409eff;
@success-color: #67c23a;
@warning-color: #e6a23c;
@danger-color: #f56c6c;
@info-color: #909399;
@text-primary: #303133;
@text-regular: #606266;
@text-secondary: #909399;
@text-placeholder: #c0c4cc;
@border-light: #ebeef5;
@border-lighter: #f2f6fc;
@background-light: #f5f7fa;

// 公共样式混入
.flex-center() {
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-base() {
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
}

.table-header() {
    background-color: @background-light;
    color: @text-regular;
    font-weight: bold;
}

.table-cell() {
    color: @text-primary;
}

.evaluationPage-container {
    width: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    padding-bottom: 20px;
}

// 页面头部
.page-header {
    .flex-center();
    justify-content: space-between;
    padding: 6px 16px;
    background-color: white;
    border-bottom: 1px solid @border-light;

    .header-left {
        .page-title {
            font-size: 22px;
            font-weight: bold;
            color: @text-primary;
        }
    }

    .header-right {
        .return-btn {
            .button-base();
            background-color: @primary-color;
            border-color: @primary-color;
            color: white;

            &:hover {
                background-color: lighten(@primary-color, 10%);
                border-color: lighten(@primary-color, 10%);
            }
        }
    }
}

// 功能卡片区域
.function-cards-section {
    background-color: white;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .cards-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .card-row {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;

            .function-card {
                flex: 1;
                min-width: 120px;
                max-width: 150px;
                height: 70px;
                background-color: #f8f9fa;
                border: 1px solid #e4e7ed;
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                .card-icon {
                    font-size: 20px;
                    color: #409eff;
                    margin-bottom: 8px;
                }

                .card-text {
                    font-size: 12px;
                    color: #606266;
                    text-align: center;
                    line-height: 1.2;
                }
            }
        }
    }
}

// 评审步骤区域
.review-steps-section {
    background-color: white;
    padding: 16px;
    flex: 1;

    .status-text {
        color: #f56c6c;
        font-weight: 500;
    }



    .operation-text {
        color: #606266;
        margin-right: 10px;
    }

    .view-link {
        color: #409eff;
        text-decoration: none;
    }
}

// 底部操作按钮区域
.bottom-actions-section {
    border-radius: 20px;
    padding: 16px;
    display: flex;
    justify-content: center;
    gap: 16px;
    z-index: 100;

    .action-btn {
        background-color: #409eff;
        border-color: #409eff;
        color: white;
        padding: 10px 20px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
    }
}

.drawer-content {
    height: 100%;
    display: flex;

    .drawer-content-left {
        width: 300px;
        background-color: white;
        padding: 20px;
        border-right: 1px solid #e4e7ed;
        display: flex;
        flex-direction: column;
        gap: 20px;

        /* 评审报告文件列表特殊样式 */
        &.report-file-list {
            background-color: #fafafa;
            padding: 0;

            .chapter-tree {
                padding: 12px;

                /* 自定义滚动条 */
                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    background-color: #dcdfe6;
                    border-radius: 3px;

                    &:hover {
                        background-color: #c0c4cc;
                    }
                }

                &::-webkit-scrollbar-track {
                    background-color: transparent;
                }
            }

            /* 文件列表项 */
            .report-file-item {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 12px 14px;
                margin-bottom: 8px;
                border-radius: 6px;
                cursor: pointer;
                font-size: 14px;
                color: #606266;
                background-color: #ffffff;
                border: 1px solid #e4e7ed;
                transition: all 0.3s ease;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

                span {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 1.5;
                }

                &:hover {
                    background-color: #f5f7fa;
                    border-color: #c6e2ff;
                    transform: translateX(2px);
                    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
                }

                &.is-active {
                    background: linear-gradient(135deg, #ecf5ff 0%, #e1f0ff 100%);
                    color: #409eff;
                    font-weight: 500;
                    border-color: #b3d8ff;
                    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }

            /* 空状态 */
            .report-file-empty {
                padding: 40px 12px;
                color: #c0c4cc;
                font-size: 14px;
                text-align: center;
                background-color: #ffffff;
                border-radius: 6px;
                border: 1px dashed #e4e7ed;
            }

            /* 底部按钮区域 */
            .report-drawer-footer {
                padding: 16px;
                border-top: 1px solid #e4e7ed;
                background-color: #ffffff;
                display: flex;
                flex-direction: column;
                gap: 10px;
                box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);

                .el-button {
                    width: 100%;
                    margin: 0;
                    height: 38px;
                    font-size: 14px;
                    border-radius: 4px;

                    &.el-button--primary {
                        background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
                        border-color: #409eff;

                        &:hover {
                            background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
                            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
                        }
                    }

                    &:not(.el-button--primary) {
                        &:hover {
                            background-color: #f5f7fa;
                            border-color: #c0c4cc;
                        }
                    }
                }
            }
        }

        .dropdown-section {
            .project-select {
                width: 100%;

                /deep/ .el-input__inner {
                    border: 1px solid #dcdfe6;
                    border-radius: 4px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 14px;
                }
            }
        }

        .chapter-title {
            text-align: start;

            h3 {
                margin: 0;
                font-size: 16px;
                font-weight: 500;
                color: #303133;
            }
        }

        .chapter-tree {
            flex: 1;
            overflow-y: auto;
            padding: 10px 0;

            .el-tree {
                background: transparent;
            }

            .custom-tree-node {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                padding-right: 8px;
                min-width: 0;

                >span:first-child {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    min-width: 0;
                }

                .page-num {
                    color: #909399;
                    font-size: 12px;
                    margin-left: 10px;
                    flex-shrink: 0;
                }
            }

            .el-tree-node__content {
                height: 32px;
                cursor: pointer;

                &:hover {
                    background-color: #f5f7fa;
                }
            }

            .el-tree-node.is-current>.el-tree-node__content {
                background-color: #ecf5ff;
                color: #409eff;
            }
        }
    }

    .drawer-content-right {
        flex: 1;
        background-color: white;
        position: relative;

        .pdf-viewer-container {
            height: 100%;
            display: flex;
            flex-direction: column;

            .pdf-toolbar {
                background-color: white;
                border-bottom: 1px solid #e4e7ed;
                padding: 10px 15px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                .pdf-controls {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .page-info {
                        font-size: 14px;
                        color: #606266;
                        margin: 0 10px;
                        min-width: 80px;
                        text-align: center;
                    }

                    .zoom-level {
                        font-size: 14px;
                        color: #606266;
                        margin: 0 5px;
                        min-width: 50px;
                        text-align: center;
                    }
                }
            }

            .pdf-content {
                flex: 1;
                overflow: auto;
                padding: 20px;
                display: flex;
                justify-content: center;
                align-items: flex-start;

                .pdf-document {
                    max-width: 100%;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    border-radius: 4px;
                }

                .pdf-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 300px;
                    color: #909399;

                    i {
                        font-size: 48px;
                        margin-bottom: 16px;
                    }

                    p {
                        margin: 0;
                        font-size: 16px;
                    }
                }

                .pdf-loading {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 300px;
                    color: #409eff;
                }
            }
        }
    }
}

// 抽屉标题靠左对齐
/deep/ .el-drawer__header {
    text-align: left;
}

// 附件弹窗样式
.attachment-dialog {
    .el-dialog__body {
        padding: 20px;
    }
}

.attachment-dialog-content {
    .attachment-tabs {
        .el-tabs__header {
            margin-bottom: 20px;
        }

        .el-tabs__content {
            padding: 0;
        }
    }

    .attachment-section {
        .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            padding: 10px 0;
            border-bottom: 1px solid #409eff;

            .section-icon {
                color: #409eff;
                font-size: 16px;
                margin-right: 8px;
            }

            .section-title {
                font-size: 16px;
                font-weight: bold;
                color: #303133;
            }
        }

        .attachment-table {
            .file-link {
                color: #409eff;
                text-decoration: none;
                cursor: pointer;
            }

            .no-data {
                color: #909399;
                font-style: italic;
            }
        }

        .content-display {
            .content-text {
                padding: 15px;
                background-color: #f8f9fa;
                border: 1px solid #e9ecef;
                border-radius: 4px;
                line-height: 1.6;
                color: #333;
                white-space: pre-wrap;
                word-break: break-word;
            }

            .no-data {
                color: #909399;
                font-style: italic;
                text-align: center;
                padding: 20px;
            }
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 10px 0;

    .el-button {
        min-width: 80px;
    }
}

// 调整投标单位报价弹窗样式
.price-adjustment-dialog {
    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-dialog__headerbtn {
        top: 15px;
        right: 15px;
        font-size: 18px;
        color: #909399;
    }
}

.price-adjustment-content {
    .adjustment-history-section {
        margin-bottom: 20px;

        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 10px;
        }

        .adjustment-history-table {
            .el-table__empty-text {
                color: #909399;
                font-style: italic;
            }
        }
    }

    .bid-units-section {
        margin-bottom: 20px;

        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 10px;
        }

        .bid-units-table {
            .price-input-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .price-input {
                    width: 120px;

                    /deep/ .el-input__inner {
                        text-align: center;
                        padding-right: 30px;
                    }

                    /deep/ .el-input-number__controls {
                        right: 0;
                    }
                }
            }
        }
    }

    .adjustment-reason-section {
        .reason-label {
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            .required-asterisk {
                color: #f56c6c;
                margin-right: 4px;
                font-size: 14px;
            }

            .label-text {
                font-size: 14px;
                color: #606266;
                font-weight: 500;
            }
        }

        .reason-textarea {
            /deep/ .el-textarea__inner {
                resize: vertical;
                min-height: 100px;
                font-size: 14px;
                line-height: 1.5;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                padding: 10px 15px;

                &:focus {
                    border-color: #409eff;
                    outline: none;
                }

                &::placeholder {
                    color: #c0c4cc;
                }
            }
        }
    }
}

// 确认调整按钮样式
.confirm-btn {
    background-color: #409eff;
    border-color: #409eff;
    color: white;
    padding: 10px 30px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    min-width: 100px;

    &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
    }

    &:active {
        background-color: #3a8ee6;
        border-color: #3a8ee6;
    }
}

// 评标节点回退弹窗样式
.node-rollback-dialog {
    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-dialog__headerbtn {
        top: 15px;
        right: 15px;
        font-size: 18px;
        color: #909399;
    }
}

.node-rollback-content {
    .rollback-history-section {
        margin-bottom: 20px;

        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #303133;
            margin-bottom: 10px;
        }

        .rollback-history-table {
            .el-table__empty-text {
                color: #909399;
                font-style: italic;
            }
        }
    }

    .rollback-node-section,
    .remarks-section {
        margin-bottom: 20px;

        .form-item {
            display: flex;
            align-items: flex-start;
            gap: 10px;

            .form-label {
                display: flex;
                align-items: center;
                min-width: 100px;
                font-size: 14px;
                color: #606266;
                font-weight: 500;

                .required-asterisk {
                    color: #f56c6c;
                    margin-right: 4px;
                    font-size: 14px;
                }
            }

            .rollback-node-select {
                flex: 1;
                max-width: 300px;

                /deep/ .el-input__inner {
                    height: 40px;
                    line-height: 40px;
                }
            }

            .remarks-textarea {
                flex: 1;

                /deep/ .el-textarea__inner {
                    resize: vertical;
                    min-height: 80px;
                    font-size: 14px;
                    line-height: 1.5;
                    border: 1px solid #dcdfe6;
                    border-radius: 4px;
                    padding: 10px 15px;

                    &:focus {
                        border-color: #409eff;
                        outline: none;
                    }

                    &::placeholder {
                        color: #c0c4cc;
                    }
                }
            }
        }
    }

    .special-reminder {
        background-color: #fef0f0;
        border: 1px solid #fbc4c4;
        border-radius: 4px;
        padding: 15px;
        margin-bottom: 20px;
        display: flex;
        align-items: flex-start;
        gap: 10px;

        .reminder-icon {
            width: 20px;
            height: 20px;
            background-color: #f56c6c;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            flex-shrink: 0;
            margin-top: 2px;
        }

        .reminder-content {
            flex: 1;

            .reminder-title {
                text-align: start;
                font-size: 14px;
                font-weight: bold;
                color: #f56c6c;
                margin-bottom: 8px;
            }

            .reminder-text {
                font-size: 14px;
                color: #f56c6c;
                line-height: 1.5;
                margin-bottom: 4px;
                text-align: start;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

// 提交按钮样式
.submit-btn {
    background-color: #409eff;
    border-color: #409eff;
    color: white;
    padding: 10px 30px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    min-width: 100px;

    &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
    }

    &:active {
        background-color: #3a8ee6;
        border-color: #3a8ee6;
    }
}

// 评标流程终止弹窗样式
.process-termination-dialog {
    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-dialog__headerbtn {
        top: 15px;
        right: 15px;
        font-size: 18px;
        color: #909399;
    }

    .dialog-footer {
        text-align: center;
        padding: 10px 20px 20px;
        border-top: 1px solid #e4e7ed;
        margin-top: 20px;
    }
}

.process-termination-content {
    .text-input-section {
        .termination-textarea {
            /deep/ .el-textarea__inner {
                resize: vertical;
                min-height: 200px;
                font-size: 14px;
                line-height: 1.5;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                padding: 15px;
                background-color: #fff;

                &:focus {
                    border-color: #409eff;
                    outline: none;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }

                &::placeholder {
                    color: #c0c4cc;
                    font-size: 14px;
                }
            }
        }
    }
}


.benchmark-price-content {

    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f5f7fa;

    .dialog-header {
        background: #fff;
        padding: 20px 30px;
        border-bottom: 1px solid #e4e7ed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        .header-left {
            .dialog-title {
                margin: 0;
                font-size: 24px;
                font-weight: bold;
                color: #303133;
            }
        }

        .header-right {
            display: flex;
            gap: 15px;

            .close-btn {
                background: #409eff;
                border-color: #409eff;
                padding: 10px 20px;
                font-size: 14px;
                font-weight: 500;
            }

            .calculate-btn {
                background: #67c23a;
                border-color: #67c23a;
                padding: 10px 20px;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    .bidder-table-container {
        margin: 20px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;

        .benchmark-price-table {
            .company-name {
                font-weight: 500;
                color: #303133;
            }

            .company-code {
                color: #606266;
                font-family: 'Courier New', monospace;
            }

            .quote-amount {
                font-weight: 600;
                color: #e6a23c;
                font-size: 16px;
            }
        }
    }

    .calculation-rules {
        margin: 0 20px 20px;
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .rules-title {
            margin: 0 0 15px 0;
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }

        .rules-content {
            p {
                margin: 8px 0;
                line-height: 1.6;
                color: #606266;
                font-size: 14px;
            }
        }
    }

    .calculation-result {
        margin: 0 20px 20px;
        background: #fff;
        border-radius: 8px;
        padding: 30px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .result-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 500px;
            margin: 0 auto;
        }

        .result-item {
            display: flex;
            align-items: center;
            margin-bottom: 25px;
            width: 100%;
            justify-content: center;

            &:last-child {
                margin-bottom: 0;
            }

            .result-label {
                min-width: 150px;
                font-weight: 500;
                color: #303133;
                font-size: 14px;
                text-align: right;
                margin-right: 15px;
            }

            .result-input {
                width: 200px;

                /deep/ .el-input__inner {
                    background-color: #f5f7fa;
                    color: #606266;
                    font-weight: 500;
                }
            }

            .fluctuation-input {
                width: 120px;
            }

            .percentage-symbol {
                margin-left: 8px;
                font-size: 14px;
                color: #606266;
                font-weight: 500;
            }
        }

        .calculate-button-container {
            margin-top: 20px;
            display: flex;
            justify-content: center;

            .calculate-btn {
                background: #67c23a;
                border-color: #67c23a;
                padding: 12px 30px;
                font-size: 16px;
                font-weight: 500;
                border-radius: 6px;
                min-width: 120px;

                &:hover {
                    background: #5daf34;
                    border-color: #5daf34;
                }
            }
        }
    }
}

// 计算报价得分弹窗样式
.bid-score-dialog {
    .bid-score-content {
        display: flex;
        flex-direction: column;
        background: #f5f7fa;

        .dialog-header {
            background: #fff;
            padding: 20px 30px;
            border-bottom: 1px solid #e4e7ed;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .bidder-table-container {
            margin: 20px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            flex: 1;
            overflow: hidden;

            .bid-score-table {
                height: 100%;

                .company-name {
                    font-weight: 500;
                    color: #303133;
                }

                .company-code {
                    color: #606266;
                    font-size: 13px;
                }

                .bid-price {
                    font-weight: 600;
                    color: #e6a23c;
                    font-size: 15px;
                }

                .score-value {
                    font-weight: 600;
                    color: #67c23a;
                    font-size: 15px;
                }
            }
        }

        .calculation-rules {
            margin: 0 20px 20px;
            background: #fff;
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

            .rules-title {
                margin: 0 0 15px 0;
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }

            .rules-content {
                p {
                    margin: 8px 0;
                    line-height: 1.6;
                    color: #606266;
                    font-size: 14px;
                }
            }
        }

        .calculate-button-container {
            margin: 0 20px 20px;
            display: flex;
            justify-content: center;

            .calculate-btn {
                background: #409eff;
                border-color: #409eff;
                padding: 12px 30px;
                font-size: 16px;
                font-weight: 500;
                border-radius: 6px;
                min-width: 120px;

                &:hover {
                    background: #66b1ff;
                    border-color: #66b1ff;
                }
            }
        }
    }
}

// 推荐中标候选人弹窗样式
.winner-candidate-content {
    .candidate-table-container {
        margin-bottom: 20px;

        .winner-candidate-table {
            .company-name {
                font-weight: 500;
                color: #303133;
            }

            .final-price {
                font-weight: 600;
                color: #e6a23c;
                font-size: 14px;
            }

            .el-checkbox {
                .el-checkbox__label {
                    color: #409eff;
                    font-weight: 500;
                }
            }
        }
    }

    .adjustment-reason-container {
        display: flex;
        align-items: flex-start;
        gap: 12px;

        .reason-label {
            font-size: 14px;
            color: #606266;
            font-weight: 500;
            min-width: 80px;
            padding-top: 8px;
        }

        .reason-input {
            flex: 1;

            .el-textarea__inner {
                border-radius: 4px;
                border-color: #dcdfe6;
                font-size: 14px;
                line-height: 1.5;

                &:focus {
                    border-color: #409eff;
                }
            }
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 20px 0 0 0;

    .el-button {
        margin: 0 8px;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px;

        &.el-button--primary {
            background: #409eff;
            border-color: #409eff;

            &:hover {
                background: #66b1ff;
                border-color: #66b1ff;
            }
        }
    }
}

// 异常行为识别弹窗样式
.abnormal-behavior-dialog {
    .el-dialog__header {
        padding: 15px 20px;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 0;
        max-height: 70vh;
        overflow: hidden;
    }

    .el-dialog__headerbtn {
        top: 15px;
        right: 15px;
        font-size: 18px;
        color: #909399;
    }
}

.abnormal-behavior-content {
    .el-table {
        border: none;

        /deep/ .el-table__header-wrapper {
            .el-table__header {
                th {
                    background-color: #f5f7fa;
                    color: #303133;
                    font-weight: 600;
                    font-size: 14px;
                    padding: 12px 0;
                    border-bottom: 1px solid #e4e7ed;
                    border-right: 1px solid #e4e7ed;

                    &:last-child {
                        border-right: none;
                    }
                }
            }
        }

        /deep/ .el-table__body-wrapper {
            .el-table__body {
                tr {
                    td {
                        padding: 12px 8px;
                        border-bottom: 1px solid #e4e7ed;
                        border-right: 1px solid #e4e7ed;
                        font-size: 13px;
                        color: #606266;

                        &:last-child {
                            border-right: none;
                        }
                    }

                    &:hover {
                        background-color: #f5f7fa;
                    }
                }
            }
        }

        /deep/ .el-table__border-left-patch {
            display: none;
        }

        /deep/ .el-table__border-bottom-patch {
            display: none;
        }
    }

    .highlight-red {
        color: #f56c6c;
        font-weight: 500;
    }

    .warning-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        justify-content: center;

        .warning-tag {
            background-color: #f56c6c;
            border-color: #f56c6c;
            color: white;
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 12px;
            margin: 1px;
        }
    }
}

// 形式评审标准弹窗样式
.formal-review-dialog {
    .el-dialog {
        width: 100vw !important;
        height: 100vh !important;
        margin: 0 !important;
        max-height: none !important;
        border-radius: 0 !important;
    }

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0 !important;
        height: 100vh;
        overflow: hidden;
    }
}

.formal-review-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;

    .formal-review-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        border-bottom: 1px solid #e4e7ed;
        background-color: white;

        .header-left {
            .review-title {
                font-size: 24px;
                font-weight: bold;
                color: #000;
                margin: 0;
            }
        }

        .header-right {
            display: flex;
            gap: 15px;

            .one-click-pass-btn,
            .close-btn {
                background-color: #409eff;
                border-color: #409eff;
                color: white;
                padding: 10px 20px;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    .review-table-container {
        flex: 1;
        padding: 20px 30px;
        overflow: auto;

        .formal-review-table {
            .company-cell {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;

                .company-name {
                    font-size: 14px;
                    color: #303133;
                    text-align: center;
                    line-height: 1.4;
                }

                .pass-all-btn {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: white;
                    font-size: 12px;
                    padding: 4px 8px;
                }
            }

            .radio-symbol {
                font-size: 16px;
                font-weight: bold;
                color: #303133;
            }

            // 单选框样式调整
            /deep/ .el-radio-group {
                display: flex;
                justify-content: center;
                gap: 15px;
            }

            /deep/ .el-radio {
                margin-right: 0;
            }

            /deep/ .el-radio__label {
                padding-left: 5px;
            }
        }
    }
}

// 专家打分弹窗样式
.expert-scoring-dialog {
    .el-dialog {
        width: 100vw !important;
        height: 100vh !important;
        margin: 0 !important;
        max-height: none !important;
        border-radius: 0 !important;
    }

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0 !important;
        height: 100vh;
        overflow: hidden;
    }
}

.expert-scoring-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;

    .expert-scoring-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        border-bottom: 1px solid #e4e7ed;
        background-color: white;

        .header-left {
            .scoring-title {
                font-size: 24px;
                font-weight: bold;
                color: #000;
                margin: 0;
            }
        }

        .header-right {
            display: flex;
            gap: 15px;

            .one-click-score-btn,
            .close-btn,
            .submit-effective-btn {
                background-color: #409eff;
                border-color: #409eff;
                color: white;
                padding: 10px 20px;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    .scoring-table-container {
        flex: 1;
        padding: 20px 30px;
        overflow: auto;

        .expert-scoring-table {
            .company-cell {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;

                .company-name {
                    font-size: 14px;
                    color: #303133;
                    text-align: center;
                    line-height: 1.4;
                }

                .score-all-btn {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: white;
                    font-size: 12px;
                    padding: 4px 8px;
                }
            }

            // 数字输入框样式调整
            /deep/ .score-input {
                width: 100px;

                .el-input__inner {
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                }

                .el-input-number__controls {

                    .el-input-number__increase,
                    .el-input-number__decrease {
                        width: 20px;
                        font-size: 12px;
                    }
                }
            }
        }
    }

    /* PDF 空状态（右侧） */
    .report-pdf-empty {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #c0c4cc;
        gap: 16px;
        background-color: #fafafa;

        i {
            font-size: 64px;
            opacity: 0.5;
        }

        p {
            margin: 0;
            font-size: 15px;
            color: #909399;
        }
    }
}

/* 密码验证弹窗样式 */
.password-dialog {
    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-dialog__footer {
        padding: 10px 20px 20px;
        text-align: center;
        border-top: 1px solid #e4e7ed;

        .el-button {
            margin: 0 8px;
            padding: 10px 20px;
            font-size: 14px;
            border-radius: 4px;

            &.el-button--primary {
                background: #409eff;
                border-color: #409eff;

                &:hover {
                    background: #66b1ff;
                    border-color: #66b1ff;
                }
            }
        }
    }
}

.password-dialog-content {
    .password-input-section {
        text-align: center;

        .password-input {
            width: 100%;
            max-width: 300px;

            /deep/ .el-input__inner {
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                padding: 0 15px;

                &:focus {
                    border-color: #409eff;
                    outline: none;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }

                &::placeholder {
                    color: #c0c4cc;
                }
            }

            /deep/ .el-input__suffix {
                .el-input__suffix-inner {
                    .el-input__icon {
                        color: #c0c4cc;
                        cursor: pointer;

                        &:hover {
                            color: #409eff;
                        }
                    }
                }
            }
        }
    }
}

.content-viewer {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    min-height: 300px;
    padding: 12px;
    background-color: #fafafa;
    font-size: 14px;
    line-height: 1.6;
    color: #606266;

    // 富文本内容样式
    :deep(p) {
        margin: 8px 0;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4),
    :deep(h5),
    :deep(h6) {
        margin: 16px 0 8px 0;
        font-weight: 600;

        &:first-child {
            margin-top: 0;
        }
    }

    :deep(ul),
    :deep(ol) {
        margin: 8px 0;
        padding-left: 24px;
    }

    :deep(li) {
        margin: 4px 0;
    }

    :deep(blockquote) {
        margin: 8px 0;
        padding: 8px 16px;
        border-left: 4px solid #dcdfe6;
        background-color: #f5f7fa;
    }

    :deep(table) {
        border-collapse: collapse;
        width: 100%;
        margin: 8px 0;

        th,
        td {
            border: 1px solid #dcdfe6;
            padding: 8px 12px;
            text-align: left;
        }

        th {
            background-color: #f5f7fa;
            font-weight: 600;
        }
    }

    :deep(img) {
        max-width: 100%;
        height: auto;
        margin: 8px 0;
    }

    :deep(code) {
        background-color: #f5f7fa;
        padding: 2px 4px;
        border-radius: 2px;
        font-family: 'Courier New', monospace;
    }

    :deep(pre) {
        background-color: #f5f7fa;
        padding: 12px;
        border-radius: 4px;
        overflow-x: auto;
        margin: 8px 0;

        code {
            background: none;
            padding: 0;
        }
    }
}

// 文件对比弹窗中的章节树样式
/deep/ .el-drawer__body {
    .chapter-tree {
        .el-tree {
            background: transparent;
        }

        .custom-tree-node {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding-right: 8px;
            min-width: 0;

            >span:first-child {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                min-width: 0;
                font-size: 14px;
            }

            .page-num {
                color: #909399;
                font-size: 12px;
                margin-left: 10px;
                flex-shrink: 0;
            }
        }

        .el-tree-node__content {
            height: 32px;
            cursor: pointer;

            &:hover {
                background-color: #f5f7fa;
            }
        }

        .el-tree-node.is-current>.el-tree-node__content {
            background-color: #ecf5ff;
            color: #409eff;
        }
    }
}
</style>





